/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 80);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var ctx = __webpack_require__(8);
var hide = __webpack_require__(9);
var has = __webpack_require__(11);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(43)('wks');
var uid = __webpack_require__(30);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(54);
var toPrimitive = __webpack_require__(40);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(18);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(4);
var createDesc = __webpack_require__(19);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(41);
var defined = __webpack_require__(37);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(84)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(38)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(44);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(37);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(4).f;
var has = __webpack_require__(11);
var TAG = __webpack_require__(3)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89);
var global = __webpack_require__(2);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(14);
var TO_STRING_TAG = __webpack_require__(3)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(8);
var call = __webpack_require__(60);
var isArrayIter = __webpack_require__(61);
var anObject = __webpack_require__(6);
var toLength = __webpack_require__(29);
var getIterFn = __webpack_require__(46);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(81);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(83), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(86);
var enumBugKeys = __webpack_require__(44);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(39)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(57).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(36);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(20);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(101);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(49);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(106), __esModule: true };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(73);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(118);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {



/***/ }),
/* 36 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(17);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(14);
var $iterCreate = __webpack_require__(85);
var setToStringTag = __webpack_require__(21);
var getPrototypeOf = __webpack_require__(58);
var ITERATOR = __webpack_require__(3)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(5);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(20);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(43)('keys');
var uid = __webpack_require__(30);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(17) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(31);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(14);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(18);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(9);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(104), __esModule: true };

/***/ }),
/* 50 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(3);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(30)('meta');
var isObject = __webpack_require__(5);
var has = __webpack_require__(11);
var setDesc = __webpack_require__(4).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var LIBRARY = __webpack_require__(17);
var wksExt = __webpack_require__(51);
var defineProperty = __webpack_require__(4).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(39)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(11);
var toIObject = __webpack_require__(12);
var arrayIndexOf = __webpack_require__(87)(false);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(11);
var toObject = __webpack_require__(16);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(14);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(18);
var SPECIES = __webpack_require__(3)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(8);
var invoke = __webpack_require__(92);
var html = __webpack_require__(57);
var cel = __webpack_require__(39);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(20)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isObject = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(47);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var dP = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(7);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(70);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.marquee = exports.registerServiceWorker = exports.getLocation = exports.parseResponse = exports.notify = exports.read = exports.imgur = exports.waitUntil = exports.loaded = exports.ready = exports.wait = undefined;

var _from = __webpack_require__(72);

var _from2 = _interopRequireDefault(_from);

var _slicedToArray2 = __webpack_require__(32);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(33);

var _entries2 = _interopRequireDefault(_entries);

var _defineProperty = __webpack_require__(70);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getIterator2 = __webpack_require__(49);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(25);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(26);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(113);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(34);

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = __webpack_require__(77);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var wait = exports.wait = function () {
	var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ms) {
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						return _context.abrupt('return', new _promise2.default(function (resolve) {
							setTimeout(resolve, ms);
						}));

					case 1:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function wait(_x2) {
		return _ref.apply(this, arguments);
	};
}();

var ready = exports.ready = function () {
	var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
		return _regenerator2.default.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						if (!(document.readyState === 'loading')) {
							_context2.next = 3;
							break;
						}

						_context2.next = 3;
						return waitUntil(document, 'DOMContentLoaded');

					case 3:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function ready() {
		return _ref2.apply(this, arguments);
	};
}();

var loaded = exports.loaded = function () {
	var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
		return _regenerator2.default.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						if (!(document.readyState !== 'complete')) {
							_context3.next = 3;
							break;
						}

						_context3.next = 3;
						return waitUntil(window, 'load');

					case 3:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loaded() {
		return _ref3.apply(this, arguments);
	};
}();

var waitUntil = exports.waitUntil = function () {
	var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(target, event) {
		var prom;
		return _regenerator2.default.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						prom = new _promise2.default(function (resolve) {
							target.addEventListener(event, function () {
								return resolve();
							}, { once: true });
						});
						_context4.next = 3;
						return prom;

					case 3:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function waitUntil(_x3, _x4) {
		return _ref4.apply(this, arguments);
	};
}();

var imgur = exports.imgur = function () {
	var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(url) {
		var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref7$sizes = _ref7.sizes,
		    sizes = _ref7$sizes === undefined ? ['100vw'] : _ref7$sizes,
		    _ref7$alt = _ref7.alt,
		    alt = _ref7$alt === undefined ? '' : _ref7$alt,
		    _ref7$defaultSize = _ref7.defaultSize,
		    defaultSize = _ref7$defaultSize === undefined ? 'h' : _ref7$defaultSize;

		var imgurSizes, formats, picture, imgur, image;
		return _regenerator2.default.wrap(function _callee6$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						imgurSizes = {
							h: 1024,
							l: 640,
							m: 320,
							t: 160
						};
						formats = {
							'image/webp': '.webp',
							'image/png': '.png'
						};
						picture = document.createElement('picture');
						imgur = new URL(url, 'https://i.imgur.com/');
						image = new Image();


						imgur.host = 'i.imgur.com';
						imgur.protocol = 'https:';
						imgur.pathname = imgur.pathname.replace(/\.[A-z]+$/, '');
						(0, _entries2.default)(formats).forEach(function (format) {
							var _format = (0, _slicedToArray3.default)(format, 2),
							    type = _format[0],
							    ext = _format[1];

							var source = document.createElement('source');
							source.type = type;
							source.sizes = sizes.join(', ');
							var srcset = (0, _entries2.default)(imgurSizes).map(function (size) {
								var _size = (0, _slicedToArray3.default)(size, 2),
								    suffix = _size[0],
								    width = _size[1];

								return '' + imgur + suffix + ext + ' ' + width + 'w';
							});
							source.srcset = srcset.join(', ');
							picture.append(source);
						});

						return _context7.abrupt('return', new _promise2.default(function (resolve, reject) {
							picture.append(image);
							image.alt = alt;
							image.addEventListener('load', function (event) {
								return resolve(event.target.parentElement);
							}, { once: true });
							image.addEventListener('error', function (event) {
								return reject(event.target);
							});
							image.src = '' + imgur + defaultSize + '.png';
						}));

					case 10:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee6, this);
	}));

	return function imgur(_x8) {
		return _ref6.apply(this, arguments);
	};
}();

var read = exports.read = function () {
	var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
		var _this = this;

		for (var _len2 = arguments.length, nodes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			nodes[_key2] = arguments[_key2];
		}

		var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, node, _loop, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, chunk;

		return _regenerator2.default.wrap(function _callee7$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						if (window.hasOwnProperty('speechSynthesis')) {
							_context9.next = 2;
							break;
						}

						throw new Error('SpeechSynthesis not supported');

					case 2:
						_iteratorNormalCompletion2 = true;
						_didIteratorError2 = false;
						_iteratorError2 = undefined;
						_context9.prev = 5;
						_iterator2 = (0, _getIterator3.default)(nodes);

					case 7:
						if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
							_context9.next = 51;
							break;
						}

						node = _step2.value;

						if (!(typeof node === 'string')) {
							_context9.next = 38;
							break;
						}

						_loop = /*#__PURE__*/_regenerator2.default.mark(function _loop(chunk) {
							return _regenerator2.default.wrap(function _loop$(_context8) {
								while (1) {
									switch (_context8.prev = _context8.next) {
										case 0:
											_context8.next = 2;
											return new _promise2.default(function (resolve, reject) {
												var utter = new SpeechSynthesisUtterance(chunk);
												utter.addEventListener('end', resolve);
												utter.addEventListener('error', reject);
												speechSynthesis.speak(utter);
											});

										case 2:
										case 'end':
											return _context8.stop();
									}
								}
							}, _loop, _this);
						});

						/*
       * Work-around for Chrome issue with long utterances
       * <https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesis/speak#Browser_compatibility>
      */
						_iteratorNormalCompletion3 = true;
						_didIteratorError3 = false;
						_iteratorError3 = undefined;
						_context9.prev = 14;
						_iterator3 = (0, _getIterator3.default)(chunkText(node, 200));

					case 16:
						if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
							_context9.next = 22;
							break;
						}

						chunk = _step3.value;
						return _context9.delegateYield(_loop(chunk), 't0', 19);

					case 19:
						_iteratorNormalCompletion3 = true;
						_context9.next = 16;
						break;

					case 22:
						_context9.next = 28;
						break;

					case 24:
						_context9.prev = 24;
						_context9.t1 = _context9['catch'](14);
						_didIteratorError3 = true;
						_iteratorError3 = _context9.t1;

					case 28:
						_context9.prev = 28;
						_context9.prev = 29;

						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}

					case 31:
						_context9.prev = 31;

						if (!_didIteratorError3) {
							_context9.next = 34;
							break;
						}

						throw _iteratorError3;

					case 34:
						return _context9.finish(31);

					case 35:
						return _context9.finish(28);

					case 36:
						_context9.next = 48;
						break;

					case 38:
						if (!(node instanceof Text)) {
							_context9.next = 45;
							break;
						}

						node.parentElement.classList.add('reading');
						_context9.next = 42;
						return read(node.wholeText);

					case 42:
						node.parentElement.classList.remove('reading');
						_context9.next = 48;
						break;

					case 45:
						if (!(node instanceof Element && !node.hidden && node.hasChildNodes())) {
							_context9.next = 48;
							break;
						}

						_context9.next = 48;
						return read.apply(undefined, (0, _toConsumableArray3.default)(node.childNodes));

					case 48:
						_iteratorNormalCompletion2 = true;
						_context9.next = 7;
						break;

					case 51:
						_context9.next = 57;
						break;

					case 53:
						_context9.prev = 53;
						_context9.t2 = _context9['catch'](5);
						_didIteratorError2 = true;
						_iteratorError2 = _context9.t2;

					case 57:
						_context9.prev = 57;
						_context9.prev = 58;

						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}

					case 60:
						_context9.prev = 60;

						if (!_didIteratorError2) {
							_context9.next = 63;
							break;
						}

						throw _iteratorError2;

					case 63:
						return _context9.finish(60);

					case 64:
						return _context9.finish(57);

					case 65:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee7, this, [[5, 53, 57, 65], [14, 24, 28, 36], [29,, 31, 35], [58,, 60, 64]]);
	}));

	return function read() {
		return _ref8.apply(this, arguments);
	};
}();

var notify = exports.notify = function () {
	var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(title) {
		var _this2 = this;

		var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref10$body = _ref10.body,
		    body = _ref10$body === undefined ? '' : _ref10$body,
		    _ref10$icon = _ref10.icon,
		    icon = _ref10$icon === undefined ? '' : _ref10$icon,
		    _ref10$dir = _ref10.dir,
		    dir = _ref10$dir === undefined ? document.dir : _ref10$dir,
		    _ref10$lang = _ref10.lang,
		    lang = _ref10$lang === undefined ? document.documentElement.lang : _ref10$lang,
		    _ref10$tag = _ref10.tag,
		    tag = _ref10$tag === undefined ? '' : _ref10$tag,
		    _ref10$data = _ref10.data,
		    data = _ref10$data === undefined ? null : _ref10$data,
		    _ref10$vibrate = _ref10.vibrate,
		    vibrate = _ref10$vibrate === undefined ? false : _ref10$vibrate,
		    _ref10$renotify = _ref10.renotify,
		    renotify = _ref10$renotify === undefined ? false : _ref10$renotify,
		    _ref10$requireInterac = _ref10.requireInteraction,
		    requireInteraction = _ref10$requireInterac === undefined ? false : _ref10$requireInterac,
		    _ref10$actions = _ref10.actions,
		    actions = _ref10$actions === undefined ? [] : _ref10$actions,
		    _ref10$silent = _ref10.silent,
		    silent = _ref10$silent === undefined ? false : _ref10$silent,
		    _ref10$noscreen = _ref10.noscreen,
		    noscreen = _ref10$noscreen === undefined ? false : _ref10$noscreen,
		    _ref10$sticky = _ref10.sticky,
		    sticky = _ref10$sticky === undefined ? false : _ref10$sticky;

		return _regenerator2.default.wrap(function _callee10$(_context12) {
			while (1) {
				switch (_context12.prev = _context12.next) {
					case 0:
						return _context12.abrupt('return', new _promise2.default(function () {
							var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(resolve, reject) {
								var notification;
								return _regenerator2.default.wrap(function _callee9$(_context11) {
									while (1) {
										switch (_context11.prev = _context11.next) {
											case 0:
												_context11.prev = 0;

												if (window.Notification instanceof Function) {
													_context11.next = 5;
													break;
												}

												throw new Error('Notifications not supported');

											case 5:
												if (!(Notification.permission === 'denied')) {
													_context11.next = 9;
													break;
												}

												throw new Error('Notification permission denied');

											case 9:
												if (!(Notification.permission === 'default')) {
													_context11.next = 12;
													break;
												}

												_context11.next = 12;
												return new _promise2.default(function () {
													var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(resolve, reject) {
														var resp;
														return _regenerator2.default.wrap(function _callee8$(_context10) {
															while (1) {
																switch (_context10.prev = _context10.next) {
																	case 0:
																		_context10.next = 2;
																		return Notification.requestPermission();

																	case 2:
																		resp = _context10.sent;


																		if (resp === 'granted') {
																			resolve();
																		} else {
																			reject(new Error('Notification permission not granted'));
																		}

																	case 4:
																	case 'end':
																		return _context10.stop();
																}
															}
														}, _callee8, _this2);
													}));

													return function (_x14, _x15) {
														return _ref12.apply(this, arguments);
													};
												}());

											case 12:
												notification = new Notification(title, {
													body: body,
													icon: icon,
													dir: dir,
													lang: lang,
													tag: tag,
													data: data,
													vibrate: vibrate,
													renotify: renotify,
													requireInteraction: requireInteraction,
													actions: actions,
													silent: silent,
													noscreen: noscreen,
													sticky: sticky
												});


												notification.addEventListener('show', function (event) {
													return resolve(event.target);
												}, { once: true });
												notification.addEventListener('error', function (event) {
													return reject(event.target);
												}, { once: true });
												_context11.next = 20;
												break;

											case 17:
												_context11.prev = 17;
												_context11.t0 = _context11['catch'](0);

												reject(_context11.t0);

											case 20:
											case 'end':
												return _context11.stop();
										}
									}
								}, _callee9, _this2, [[0, 17]]);
							}));

							return function (_x12, _x13) {
								return _ref11.apply(this, arguments);
							};
						}()));

					case 1:
					case 'end':
						return _context12.stop();
				}
			}
		}, _callee10, this);
	}));

	return function notify(_x11) {
		return _ref9.apply(this, arguments);
	};
}();

var parseResponse = exports.parseResponse = function () {
	var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(resp) {
		var type;
		return _regenerator2.default.wrap(function _callee11$(_context13) {
			while (1) {
				switch (_context13.prev = _context13.next) {
					case 0:
						if (resp.headers.has('Content-Type')) {
							_context13.next = 4;
							break;
						}

						throw new Error('No Content-Type header in request to "' + resp.url + '"');

					case 4:
						if (!(resp.headers.get('Content-Length') === 0)) {
							_context13.next = 6;
							break;
						}

						throw new Error('No response body for "' + resp.url + '"');

					case 6:
						type = resp.headers.get('Content-Type');

						if (!type.startsWith('application/json')) {
							_context13.next = 11;
							break;
						}

						return _context13.abrupt('return', resp.json());

					case 11:
						if (!type.startsWith('application/xml')) {
							_context13.next = 19;
							break;
						}

						_context13.t0 = new DOMParser();
						_context13.next = 15;
						return resp.text();

					case 15:
						_context13.t1 = _context13.sent;
						return _context13.abrupt('return', _context13.t0.parseFromString.call(_context13.t0, _context13.t1, 'application/xml'));

					case 19:
						if (!type.startsWith('image/svg+xml')) {
							_context13.next = 27;
							break;
						}

						_context13.t2 = new DOMParser();
						_context13.next = 23;
						return resp.text();

					case 23:
						_context13.t3 = _context13.sent;
						return _context13.abrupt('return', _context13.t2.parseFromString.call(_context13.t2, _context13.t3, 'image/svg+xml'));

					case 27:
						if (!type.startsWith('text/html')) {
							_context13.next = 35;
							break;
						}

						_context13.t4 = new DOMParser();
						_context13.next = 31;
						return resp.text();

					case 31:
						_context13.t5 = _context13.sent;
						return _context13.abrupt('return', _context13.t4.parseFromString.call(_context13.t4, _context13.t5, 'text/html'));

					case 35:
						if (!type.startsWith('text/plain')) {
							_context13.next = 39;
							break;
						}

						return _context13.abrupt('return', resp.text());

					case 39:
						throw new TypeError('Unsupported Content-Type: ' + type);

					case 40:
					case 'end':
						return _context13.stop();
				}
			}
		}, _callee11, this);
	}));

	return function parseResponse(_x16) {
		return _ref13.apply(this, arguments);
	};
}();

var getLocation = exports.getLocation = function () {
	var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		return _regenerator2.default.wrap(function _callee12$(_context14) {
			while (1) {
				switch (_context14.prev = _context14.next) {
					case 0:
						return _context14.abrupt('return', new _promise2.default(function (resolve, reject) {
							if (!('geolocation' in navigator)) {
								reject('Your browser does not support GeoLocation');
							}
							navigator.geolocation.getCurrentPosition(resolve, reject, options);
						}));

					case 1:
					case 'end':
						return _context14.stop();
				}
			}
		}, _callee12, this);
	}));

	return function getLocation() {
		return _ref14.apply(this, arguments);
	};
}();

var registerServiceWorker = exports.registerServiceWorker = function () {
	var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(path) {
		var _this3 = this;

		return _regenerator2.default.wrap(function _callee14$(_context16) {
			while (1) {
				switch (_context16.prev = _context16.next) {
					case 0:
						return _context16.abrupt('return', new _promise2.default(function () {
							var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(resolve, reject) {
								var url, reg;
								return _regenerator2.default.wrap(function _callee13$(_context15) {
									while (1) {
										switch (_context15.prev = _context15.next) {
											case 0:
												_context15.prev = 0;

												if (Navigator.prototype.hasOwnProperty('serviceWorker')) {
													_context15.next = 5;
													break;
												}

												throw new Error('Service worker not supported');

											case 5:
												if (navigator.onLine) {
													_context15.next = 7;
													break;
												}

												throw new Error('Offline');

											case 7:
												url = new URL(path, document.baseURI);
												_context15.next = 10;
												return navigator.serviceWorker.register(url, { scope: document.baseURI });

											case 10:
												reg = _context15.sent;


												if (navigator.onLine) {
													reg.update();
												}

												reg.addEventListener('updatefound', function (event) {
													return resolve(event.target);
												});
												reg.addEventListener('install', function (event) {
													return resolve(event.target);
												});
												reg.addEventListener('activate', function (event) {
													return resolve(event.target);
												});
												reg.addEventListener('error', function (event) {
													return reject(event.target);
												});
												reg.addEventListener('fetch', console.info);
												_context15.next = 22;
												break;

											case 19:
												_context15.prev = 19;
												_context15.t0 = _context15['catch'](0);

												reject(_context15.t0);

											case 22:
											case 'end':
												return _context15.stop();
										}
									}
								}, _callee13, _this3, [[0, 19]]);
							}));

							return function (_x19, _x20) {
								return _ref16.apply(this, arguments);
							};
						}()));

					case 1:
					case 'end':
						return _context16.stop();
				}
			}
		}, _callee14, this);
	}));

	return function registerServiceWorker(_x18) {
		return _ref15.apply(this, arguments);
	};
}();

var marquee = exports.marquee = function () {
	var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
		var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    parent = _ref18.parent,
		    _ref18$delay = _ref18.delay,
		    delay = _ref18$delay === undefined ? 200 : _ref18$delay,
		    _ref18$cursor = _ref18.cursor,
		    cursor = _ref18$cursor === undefined ? '|' : _ref18$cursor,
		    _ref18$blinkRate = _ref18.blinkRate,
		    blinkRate = _ref18$blinkRate === undefined ? 800 : _ref18$blinkRate,
		    _ref18$pause = _ref18.pause,
		    pause = _ref18$pause === undefined ? 1000 : _ref18$pause,
		    _ref18$containerTag = _ref18.containerTag,
		    containerTag = _ref18$containerTag === undefined ? 'span' : _ref18$containerTag,
		    _ref18$cursorTag = _ref18.cursorTag,
		    cursorTag = _ref18$cursorTag === undefined ? 'span' : _ref18$cursorTag;

		for (var _len3 = arguments.length, sentences = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
			sentences[_key3 - 1] = arguments[_key3];
		}

		var cursorEl, container, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, text, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, char, chars;

		return _regenerator2.default.wrap(function _callee15$(_context17) {
			while (1) {
				switch (_context17.prev = _context17.next) {
					case 0:
						cursorEl = document.createElement(cursorTag);
						container = document.createElement(containerTag);


						if (Element.prototype.animate) {
							cursorEl.animate([{ opacity: 0 }, { opacity: 1 }], {
								duration: blinkRate,
								iterations: Infinity,
								direction: 'alternate'
							});
						}

						cursorEl.textContent = cursor;
						parent.prepend(container, cursorEl);

						_iteratorNormalCompletion4 = true;
						_didIteratorError4 = false;
						_iteratorError4 = undefined;
						_context17.prev = 8;
						_iterator4 = (0, _getIterator3.default)(toGenerator.apply(undefined, (0, _toConsumableArray3.default)(sentences)));

					case 10:
						if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
							_context17.next = 53;
							break;
						}

						text = _step4.value;

						container.textContent = '';

						_iteratorNormalCompletion5 = true;
						_didIteratorError5 = false;
						_iteratorError5 = undefined;
						_context17.prev = 16;
						_iterator5 = (0, _getIterator3.default)(text.split(''));

					case 18:
						if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
							_context17.next = 26;
							break;
						}

						char = _step5.value;

						container.append(char);
						_context17.next = 23;
						return wait(delay);

					case 23:
						_iteratorNormalCompletion5 = true;
						_context17.next = 18;
						break;

					case 26:
						_context17.next = 32;
						break;

					case 28:
						_context17.prev = 28;
						_context17.t0 = _context17['catch'](16);
						_didIteratorError5 = true;
						_iteratorError5 = _context17.t0;

					case 32:
						_context17.prev = 32;
						_context17.prev = 33;

						if (!_iteratorNormalCompletion5 && _iterator5.return) {
							_iterator5.return();
						}

					case 35:
						_context17.prev = 35;

						if (!_didIteratorError5) {
							_context17.next = 38;
							break;
						}

						throw _iteratorError5;

					case 38:
						return _context17.finish(35);

					case 39:
						return _context17.finish(32);

					case 40:
						_context17.next = 42;
						return wait(pause);

					case 42:
						if (!(container.textContent !== '')) {
							_context17.next = 50;
							break;
						}

						chars = container.textContent.split('');

						chars.pop();
						container.textContent = chars.join('');
						_context17.next = 48;
						return wait(delay);

					case 48:
						_context17.next = 42;
						break;

					case 50:
						_iteratorNormalCompletion4 = true;
						_context17.next = 10;
						break;

					case 53:
						_context17.next = 59;
						break;

					case 55:
						_context17.prev = 55;
						_context17.t1 = _context17['catch'](8);
						_didIteratorError4 = true;
						_iteratorError4 = _context17.t1;

					case 59:
						_context17.prev = 59;
						_context17.prev = 60;

						if (!_iteratorNormalCompletion4 && _iterator4.return) {
							_iterator4.return();
						}

					case 62:
						_context17.prev = 62;

						if (!_didIteratorError4) {
							_context17.next = 65;
							break;
						}

						throw _iteratorError4;

					case 65:
						return _context17.finish(62);

					case 66:
						return _context17.finish(59);

					case 67:
					case 'end':
						return _context17.stop();
				}
			}
		}, _callee15, this, [[8, 55, 59, 67], [16, 28, 32, 40], [33,, 35, 39], [60,, 62, 66]]);
	}));

	return function marquee() {
		return _ref17.apply(this, arguments);
	};
}();

exports.clone = clone;
exports.$ = $;
exports.toGenerator = toGenerator;
exports.setIncrementor = setIncrementor;
exports.selectElement = selectElement;
exports.chunkText = chunkText;
exports.query = query;
exports.isOnline = isOnline;
exports.isInternalLink = isInternalLink;

var _esQuery = __webpack_require__(125);

var _esQuery2 = _interopRequireDefault(_esQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(toGenerator);

function clone(thing) {
	if (thing instanceof Array) {
		return [].concat((0, _toConsumableArray3.default)(thing)).map(clone);
	} else if (['string', 'number'].includes(typeof thing === 'undefined' ? 'undefined' : (0, _typeof3.default)(thing))) {
		return thing;
	} else if (thing instanceof Element) {
		return thing.cloneNode(true);
	} else if (thing instanceof Function) {
		return thing;
	} else {
		return (0, _assign2.default)({}, thing);
	}
}

function $(selector) {
	var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

	return new _esQuery2.default(selector, parent);
}

function toGenerator() {
	for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
		items[_key] = arguments[_key];
	}

	var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

	return _regenerator2.default.wrap(function toGenerator$(_context5) {
		while (1) {
			switch (_context5.prev = _context5.next) {
				case 0:
					if (false) {
						_context5.next = 29;
						break;
					}

					_iteratorNormalCompletion = true;
					_didIteratorError = false;
					_iteratorError = undefined;
					_context5.prev = 4;
					_iterator = (0, _getIterator3.default)(items);

				case 6:
					if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
						_context5.next = 13;
						break;
					}

					item = _step.value;
					_context5.next = 10;
					return item;

				case 10:
					_iteratorNormalCompletion = true;
					_context5.next = 6;
					break;

				case 13:
					_context5.next = 19;
					break;

				case 15:
					_context5.prev = 15;
					_context5.t0 = _context5['catch'](4);
					_didIteratorError = true;
					_iteratorError = _context5.t0;

				case 19:
					_context5.prev = 19;
					_context5.prev = 20;

					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}

				case 22:
					_context5.prev = 22;

					if (!_didIteratorError) {
						_context5.next = 25;
						break;
					}

					throw _iteratorError;

				case 25:
					return _context5.finish(22);

				case 26:
					return _context5.finish(19);

				case 27:
					_context5.next = 0;
					break;

				case 29:
				case 'end':
					return _context5.stop();
			}
		}
	}, _marked, this, [[4, 15, 19, 27], [20,, 22, 26]]);
}

function setIncrementor(obj) {
	var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref5$key = _ref5.key,
	    key = _ref5$key === undefined ? 'i' : _ref5$key,
	    _ref5$start = _ref5.start,
	    start = _ref5$start === undefined ? 0 : _ref5$start,
	    _ref5$increment = _ref5.increment,
	    increment = _ref5$increment === undefined ? 1 : _ref5$increment;

	var inc = /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
		var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		return _regenerator2.default.wrap(function _callee5$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						if (false) {
							_context6.next = 6;
							break;
						}

						_context6.next = 3;
						return n;

					case 3:
						n += increment;
						_context6.next = 0;
						break;

					case 6:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee5, this);
	})(obj.hasOwnProperty(key) ? obj[key] : start);

	return (0, _defineProperty2.default)(obj, key, {
		get: function get() {
			return inc.next().value;
		},
		enumerable: true
	});
}

function selectElement(el) {
	if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
		el.select();
	} else if (window.getSelection) {
		var selection = getSelection();
		var range = document.createRange();
		range.selectNodeContents(el);
		selection.removeAllRanges();
		selection.addRange(range);
	} else if (document.body.createTextRange) {
		var _range = document.body.createTextRange();
		_range.moveToElementText(el);
		_range.select();
	} else {
		throw new Error('Text selection is not supported');
	}
}

function chunkText(string, length) {
	var size = Math.ceil(string.length / length);
	var chunks = Array(size);

	for (var i = 0, offset = 0; i < size; i++, offset++) {
		chunks[i] = string.substr(offset, length);
	}
	return chunks;
}

function query(selector) {
	var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

	var results = (0, _from2.default)(node.querySelectorAll(selector));
	if (node.matches(selector)) {
		results.unshift(node);
	}
	return results;
}

function isOnline() {
	return navigator.onLine === true;
}

function isInternalLink(link) {
	return link.origin === location.origin;
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(110), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(117), __esModule: true };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(20);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(56);
var hiddenKeys = __webpack_require__(44).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(24);
var createDesc = __webpack_require__(19);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(40);
var has = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(54);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(72);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(0);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(25);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(26);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

__webpack_require__(97);

__webpack_require__(109);

var _functions = __webpack_require__(71);

var _webShareApi = __webpack_require__(158);

var _webShareApi2 = _interopRequireDefault(_webShareApi);

var _shareConfig = __webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _webShareApi2.default)(_shareConfig.facebook, _shareConfig.twitter, _shareConfig.googlePlus, _shareConfig.linkedIn, _shareConfig.reddit, _shareConfig.gmail);

(0, _functions.loaded)().then((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	return _regenerator2.default.wrap(function _callee$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					if (document.documentElement.dataset.hasOwnProperty('serviceWorker')) {
						(0, _functions.registerServiceWorker)(document.documentElement.dataset.serviceWorker);
					}

					(0, _functions.$)('[data-show-modal]').click(function (event) {
						var target = event.target.closest('[data-show-modal]');
						var dialog = document.querySelector(target.dataset.showModal);
						if (dialog instanceof HTMLElement) {
							dialog.showModal();
						}
					});
					(0, _functions.$)('[data-close]').click(function (event) {
						var target = event.target.closest('[data-close]');
						var dialog = document.querySelector(target.dataset.close);
						if (dialog instanceof HTMLElement) {
							dialog.close();
						}
					});
					(0, _functions.$)('[data-share]').click(function (event) {
						event.preventDefault();
						event.stopPropagation();
						navigator.share({
							title: document.title,
							url: location.href,
							text: document.querySelector('meta[name="description"][content]').getAttribute('content')
						});
					});

				case 4:
				case 'end':
					return _context.stop();
			}
		}
	}, _callee, undefined);
})));

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(82);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35);
__webpack_require__(13);
__webpack_require__(22);
__webpack_require__(91);
__webpack_require__(95);
__webpack_require__(96);
module.exports = __webpack_require__(0).Promise;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(36);
var defined = __webpack_require__(37);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(28);
var descriptor = __webpack_require__(19);
var setToStringTag = __webpack_require__(21);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(9)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(4);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(15);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(12);
var toLength = __webpack_require__(29);
var toAbsoluteIndex = __webpack_require__(88);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(36);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(90);
var step = __webpack_require__(59);
var Iterators = __webpack_require__(14);
var toIObject = __webpack_require__(12);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(38)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(17);
var global = __webpack_require__(2);
var ctx = __webpack_require__(8);
var classof = __webpack_require__(31);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(5);
var aFunction = __webpack_require__(18);
var anInstance = __webpack_require__(45);
var forOf = __webpack_require__(23);
var speciesConstructor = __webpack_require__(62);
var task = __webpack_require__(63).set;
var microtask = __webpack_require__(93)();
var newPromiseCapabilityModule = __webpack_require__(47);
var perform = __webpack_require__(64);
var userAgent = __webpack_require__(94);
var promiseResolve = __webpack_require__(65);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(48)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(21)($Promise, PROMISE);
__webpack_require__(66)(PROMISE);
Wrapper = __webpack_require__(0)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(67)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(63).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(20)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(0);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(62);
var promiseResolve = __webpack_require__(65);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(47);
var perform = __webpack_require__(64);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Notification = __webpack_require__(98);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.hasOwnProperty('Notification')) {
	window.Notification = _Notification2.default;
}

if (document.createElement('dialog') instanceof HTMLUnknownElement && !HTMLElement.prototype.hasOwnProperty('open')) {
	HTMLElement.prototype.show = function () {
		this.open = true;
	};

	HTMLElement.prototype.close = function () {
		var returnValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		this.open = false;
		if (this.tagName === 'DIALOG') {
			var event = new CustomEvent('close');
			if (typeof returnValue === 'string') {
				event.returnValue = true;
				this.returnValue = returnValue;
			}
			this.dispatchEvent(event);
			delete this.returnValue;
		}
	};

	Object.defineProperty(HTMLElement.prototype, 'open', {
		set: function set(open) {
			if (open) {
				this.setAttribute('open', '');
			} else {
				this.removeAttribute('open');
				if (this.tagName === 'DIALOG') {
					this.classList.remove('modal');
					var next = this.nextElementSibling;
					if (next instanceof HTMLElement && next.matches('.backdrop')) {
						next.remove();
					}
				}
			}
		},
		get: function get() {
			return this.hasAttribute('open');
		}
	});
}
if (!document.createElement('dialog').hasOwnProperty('showModal')) {
	HTMLElement.prototype.showModal = function () {
		this.open = true;
		this.classList.add('modal');
		var backdrop = document.createElement('div');
		backdrop.classList.add('backdrop');
		this.after(backdrop);
	};
}

if (!('content' in document.createElement('template'))) {
	Object.defineProperty(HTMLUnknownElement.prototype, 'content', {
		get: function get() {
			var frag = document.createDocumentFragment();
			for (var i = 0; i < this.childNodes.length; i++) {
				frag.appendChild(this.childNodes[i].cloneNode(true));
			}
			return frag;
		}
	});
}

if (!HTMLElement.prototype.hasOwnProperty('contextMenu')) {
	Object.defineProperty(HTMLElement.prototype, 'contextMenu', {
		get: function get() {
			if (this.hasAttribute('contextmenu')) {
				return document.getElementById(this.getAttribute('contextmenu'));
			}
		}
	});
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(25);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(26);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(68);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(69);

var _createClass3 = _interopRequireDefault(_createClass2);

var _slicedToArray2 = __webpack_require__(32);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(33);

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function css(element, props) {
	(0, _entries2.default)(props).forEach(function (_ref) {
		var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
		    key = _ref2[0],
		    value = _ref2[1];

		return element.style.setProperty(key, value);
	});
	return element;
}

var Notification = function () {
	function Notification(title) {
		var _this = this;

		var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref3$body = _ref3.body,
		    body = _ref3$body === undefined ? '' : _ref3$body,
		    _ref3$icon = _ref3.icon,
		    icon = _ref3$icon === undefined ? '' : _ref3$icon,
		    _ref3$dir = _ref3.dir,
		    dir = _ref3$dir === undefined ? 'auto' : _ref3$dir,
		    _ref3$lang = _ref3.lang,
		    lang = _ref3$lang === undefined ? '' : _ref3$lang,
		    _ref3$onclick = _ref3.onclick,
		    onclick = _ref3$onclick === undefined ? null : _ref3$onclick,
		    _ref3$onerror = _ref3.onerror,
		    onerror = _ref3$onerror === undefined ? null : _ref3$onerror;

		(0, _classCallCheck3.default)(this, Notification);

		this.title = title;
		this.body = body;
		this.icon = icon;
		this._dialog = document.createElement('dialog');
		this._dialog.lang = lang;
		this._dialog.dir = dir;
		this.onclick = onclick;
		this.onerror = onerror;

		try {
			var titleEl = document.createElement('b');
			var img = new Image(60, 60);
			var msg = document.createElement('div');
			var btn = document.createElement('button');
			var container = document.createElement('div');

			btn.type = 'button';
			btn.textContent = 'X';

			titleEl.textContent = title;

			css(btn, {
				position: 'absolute',
				right: '3px',
				top: '3px',
				background: 'transparent',
				border: 'none',
				color: '#000'
			});

			css(titleEl, {
				display: 'block',
				margin: '8px'
			});

			css(img, {
				float: 'left',
				'max-height': '60px',
				'max-width': '60px',
				height: 'auto',
				width: 'auto',
				'margin-right': '10px'
			});

			css(msg, {
				float: 'left',
				display: 'inline-block'
			});

			css(this._dialog, {
				background: '#FEFEFE',
				'font-family': 'system-ui',
				'font-size': '14px',
				clear: 'both',
				border: 'none',
				position: 'fixed',
				top: '12px',
				right: '12px',
				left: 'initial',
				width: '320px',
				height: '110px',
				padding: '4px',
				'border-radius': '2px',
				'box-shadow': '4px 4px 4px rgba(0,0,0,0.7)'
			});

			css(container, {
				clear: 'both',
				padding: '2px'
			});

			img.src = icon;
			msg.textContent = body;

			container.append(img, msg);
			this._dialog.append(titleEl, btn, container);

			btn.addEventListener('click', function () {
				_this.close();
			});

			this.addEventListener('click', function (event) {
				if (_this.onclick instanceof Function) {
					_this.onclick(event);
				}
				_this.close();
			});

			this.addEventListener('error', function (event) {
				if (_this.onerror instanceof Function) {
					_this.onerror(event);
				}
			});
			setTimeout(function () {
				document.body.append(_this._dialog);
				if (_this._dialog.show instanceof Function) {
					_this._dialog.show();
				}
				if (Element.prototype.animate instanceof Function) {
					_this._dialog.animate([{
						opacity: 0,
						top: '-120px'
					}, {
						opacity: 1,
						top: '12px'
					}], {
						duration: 400,
						easing: 'ease-in-out',
						fill: 'both'
					});
				}
				_this.dispatchEvent(new CustomEvent('show'));
			}, 10);
		} catch (error) {
			this.dispatchEvent(new ErrorEvent(error));
		}
	}

	(0, _createClass3.default)(Notification, [{
		key: 'close',
		value: function close() {
			var _this2 = this;

			try {
				if (Element.prototype.animate instanceof Function) {
					var anim = this._dialog.animate([{
						opacity: 1,
						top: '12px'
					}, {
						opacity: 0,
						top: '-120px'
					}], {
						duration: 400,
						easing: 'ease-in-out',
						fill: 'both'
					});
					anim.addEventListener('finish', function () {
						_this2._dialog.remove();
					});
				} else {
					this._dialog.remove();
				}
				this.dispatchEvent(new CustomEvent('close'));
			} catch (error) {
				this.dispatchEvent(new ErrorEvent(error));
			}
		}
	}, {
		key: 'addEventListener',
		value: function addEventListener() {
			var _dialog;

			(_dialog = this._dialog).addEventListener.apply(_dialog, arguments);
		}
	}, {
		key: 'dispatchEvent',
		value: function dispatchEvent(event) {
			this._dialog.dispatchEvent(event, this);
		}
	}], [{
		key: 'requestPermission',
		value: function () {
			var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								return _context.abrupt('return', Notification.permission);

							case 1:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function requestPermission() {
				return _ref4.apply(this, arguments);
			}

			return requestPermission;
		}()
	}, {
		key: 'permission',
		get: function get() {
			return 'granted';
		}
	}]);
	return Notification;
}();

exports.default = Notification;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperty: __webpack_require__(4).f });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(102), __esModule: true };

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(22);
__webpack_require__(13);
module.exports = __webpack_require__(103);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(31);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(14);
module.exports = __webpack_require__(0).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(22);
__webpack_require__(13);
module.exports = __webpack_require__(105);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var get = __webpack_require__(46);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
module.exports = __webpack_require__(0).Object.entries;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(108)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(15);
var toIObject = __webpack_require__(12);
var isEnum = __webpack_require__(24).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!('Notification' in window)) {
	window.Notification = window.notifications || window.webkitNotifications || window.oNotifications || window.msNotifications || false;
}
if (!('indexedDB' in window)) {
	window.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || false;
}
if (!('hidden' in document)) {
	document.hidden = document.webkitHidden || document.msHidden || document.mozHidden || false;
}
if (!('visibilityState' in document)) {
	document.visibilityState = document.webkitVisibilityState || document.msVisibilityState || document.mozVisibilityState || 'visible';
}
if (!('fullscreenElement' in document)) {
	document.fullscreenElement = document.mozFullScreenElement || document.webkitFullscreenElement || false;
}
if (!('requestAnimationFrame' in window)) {
	window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || false;
}
if (!('exitFullscreen' in Document.prototype)) {
	Document.prototype.exitFullscreen = document.mozCancelFullScreen || document.webkitCancelFullScreen || document.msCancelFullScreen || false;
}
if (!('requestFullscreen' in HTMLElement.prototype)) {
	HTMLElement.prototype.requestFullScreen = HTMLElement.prototype.mozRequestFullScreen || HTMLElement.prototype.webkitRequestFullScreen || false;
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
__webpack_require__(111);
module.exports = __webpack_require__(0).Array.from;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(8);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var call = __webpack_require__(60);
var isArrayIter = __webpack_require__(61);
var toLength = __webpack_require__(29);
var createProperty = __webpack_require__(112);
var getIterFn = __webpack_require__(46);

$export($export.S + $export.F * !__webpack_require__(67)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(4);
var createDesc = __webpack_require__(19);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(116) });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(15);
var gOPS = __webpack_require__(50);
var pIE = __webpack_require__(24);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(41);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
__webpack_require__(22);
module.exports = __webpack_require__(51).f('iterator');


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(119), __esModule: true };

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
__webpack_require__(35);
__webpack_require__(123);
__webpack_require__(124);
module.exports = __webpack_require__(0).Symbol;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(55);
var META = __webpack_require__(52).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(43);
var setToStringTag = __webpack_require__(21);
var uid = __webpack_require__(30);
var wks = __webpack_require__(3);
var wksExt = __webpack_require__(51);
var wksDefine = __webpack_require__(53);
var enumKeys = __webpack_require__(121);
var isArray = __webpack_require__(74);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(5);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(40);
var createDesc = __webpack_require__(19);
var _create = __webpack_require__(28);
var gOPNExt = __webpack_require__(122);
var $GOPD = __webpack_require__(76);
var $DP = __webpack_require__(4);
var $keys = __webpack_require__(15);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(75).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(24).f = $propertyIsEnumerable;
  __webpack_require__(50).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(17)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(9)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(15);
var gOPS = __webpack_require__(50);
var pIE = __webpack_require__(24);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(12);
var gOPN = __webpack_require__(75).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('asyncIterator');


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('observable');


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _set = __webpack_require__(126);

var _set2 = _interopRequireDefault(_set);

var _stringify = __webpack_require__(141);

var _stringify2 = _interopRequireDefault(_stringify);

var _entries = __webpack_require__(33);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(49);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(32);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(77);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(143);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(25);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(26);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _typeof2 = __webpack_require__(34);

var _typeof3 = _interopRequireDefault(_typeof2);

var _iterator3 = __webpack_require__(73);

var _iterator4 = _interopRequireDefault(_iterator3);

var _getPrototypeOf = __webpack_require__(146);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(68);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(69);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(149);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(150);

var _inherits3 = _interopRequireDefault(_inherits2);

var _functions = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIXES = ['', 'moz', 'webkit', 'ms'];

/*============================ esQuery Functions =======================*/

var esQuery = function (_Set) {
	(0, _inherits3.default)(esQuery, _Set);

	function esQuery(selector) {
		var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
		(0, _classCallCheck3.default)(this, esQuery);

		if (typeof selector === 'string') {
			var _this = (0, _possibleConstructorReturn3.default)(this, (esQuery.__proto__ || (0, _getPrototypeOf2.default)(esQuery)).call(this, parent.querySelectorAll(selector)));

			if (parent instanceof HTMLElement && parent.matches(selector)) {
				_this.add(parent);
			}
		} else if (selector[_iterator4.default] instanceof Function) {
			var _this = (0, _possibleConstructorReturn3.default)(this, (esQuery.__proto__ || (0, _getPrototypeOf2.default)(esQuery)).call(this, selector));
		} else if ((typeof selector === 'undefined' ? 'undefined' : (0, _typeof3.default)(selector)) === 'object') {
			var _this = (0, _possibleConstructorReturn3.default)(this, (esQuery.__proto__ || (0, _getPrototypeOf2.default)(esQuery)).call(this, [selector]));
		} else {
			var _this = (0, _possibleConstructorReturn3.default)(this, (esQuery.__proto__ || (0, _getPrototypeOf2.default)(esQuery)).call(this));

			throw new TypeError('Expected a string or NodeList but got a ' + (typeof selector === 'undefined' ? 'undefined' : (0, _typeof3.default)(selector)) + ': ' + selector + '.');
		}
		return (0, _possibleConstructorReturn3.default)(_this);
	}

	(0, _createClass3.default)(esQuery, [{
		key: 'text',
		value: function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(str) {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.forEach(function (node) {
									return node.textContent = str;
								});
								return _context.abrupt('return', this);

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function text(_x2) {
				return _ref.apply(this, arguments);
			}

			return text;
		}()
	}, {
		key: 'html',
		value: function () {
			var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_html) {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								this.forEach(function (node) {
									return node.innerHTML = _html;
								});
								return _context2.abrupt('return', this);

							case 2:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function html(_x3) {
				return _ref2.apply(this, arguments);
			}

			return html;
		}()
	}, {
		key: 'replaceText',
		value: function () {
			var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
				var replacements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								this.forEach(function (el) {
									return (0, _keys2.default)(replacements).forEach(function (find) {
										el.textContent = el.textContent.replace(find, replacements[find]);
									});
								});
								return _context3.abrupt('return', this);

							case 2:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function replaceText() {
				return _ref3.apply(this, arguments);
			}

			return replaceText;
		}()
	}, {
		key: 'visible',
		value: function () {
			var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								return _context4.abrupt('return', this.css({ visibility: 'visible' }));

							case 1:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, this);
			}));

			function visible() {
				return _ref4.apply(this, arguments);
			}

			return visible;
		}()
	}, {
		key: 'invisible',
		value: function () {
			var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								return _context5.abrupt('return', this.css({ visibility: 'hidden' }));

							case 1:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, this);
			}));

			function invisible() {
				return _ref5.apply(this, arguments);
			}

			return invisible;
		}()
	}, {
		key: 'each',
		value: function () {
			var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(callback) {
				var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
				var n;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								n = 0;

								this.forEach(function (el) {
									return callback.call(thisArg, el, n++);
								});
								return _context6.abrupt('return', this);

							case 3:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, this);
			}));

			function each(_x6) {
				return _ref6.apply(this, arguments);
			}

			return each;
		}()

		/**
   * Note: This is for `HTMLDialogElement.prototype.show`, not the inverse
   * of `hide`
   */

	}, {
		key: 'show',
		value: function () {
			var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
				return _regenerator2.default.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								this.forEach(function (node) {
									if ('show' in node) {
										node.show();
									}
								});
								return _context7.abrupt('return', this);

							case 2:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, this);
			}));

			function show() {
				return _ref7.apply(this, arguments);
			}

			return show;
		}()
	}, {
		key: 'showModal',
		value: function () {
			var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
				return _regenerator2.default.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								this.forEach(function (node) {
									if ('showModal' in node) {
										node.showModal();
									}
								});
								return _context8.abrupt('return', this);

							case 2:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, this);
			}));

			function showModal() {
				return _ref8.apply(this, arguments);
			}

			return showModal;
		}()
	}, {
		key: 'close',
		value: function () {
			var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
				return _regenerator2.default.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								this.forEach(function (node) {
									if ('close' in node) {
										node.close();
									}
								});
								return _context9.abrupt('return', this);

							case 2:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, this);
			}));

			function close() {
				return _ref9.apply(this, arguments);
			}

			return close;
		}()
	}, {
		key: 'animate',
		value: function () {
			var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(keyframes) {
				var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
				return _regenerator2.default.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								if (!('animate' in Element.prototype)) {
									_context10.next = 9;
									break;
								}

								_context10.t0 = _promise2.default;
								_context10.next = 4;
								return this.map(function (node) {
									return new _promise2.default(function (resolve, reject) {
										var anim = node.animate(keyframes, opts);
										anim.onfinish = function () {
											return resolve(node);
										};
										anim.oncancel = reject;
									});
								});

							case 4:
								_context10.t1 = _context10.sent;

								_context10.t2 = function (els) {
									return new esQuery(els);
								};

								return _context10.abrupt('return', _context10.t0.all.call(_context10.t0, _context10.t1).then(_context10.t2));

							case 9:
								return _context10.abrupt('return', _promise2.default.resolve([]));

							case 10:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee10, this);
			}));

			function animate(_x8) {
				return _ref10.apply(this, arguments);
			}

			return animate;
		}()
	}, {
		key: 'getAnimations',
		value: function () {
			var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
				var anims;
				return _regenerator2.default.wrap(function _callee11$(_context11) {
					while (1) {
						switch (_context11.prev = _context11.next) {
							case 0:
								anims = [];

								this.forEach(function (el) {
									var elAnims = el.getAnimations();
									anims = anims.concat(elAnims);
								});
								return _context11.abrupt('return', anims);

							case 3:
							case 'end':
								return _context11.stop();
						}
					}
				}, _callee11, this);
			}));

			function getAnimations() {
				return _ref11.apply(this, arguments);
			}

			return getAnimations;
		}()
	}, {
		key: 'playAnimations',
		value: function () {
			var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
				for (var _len = arguments.length, ids = Array(_len), _key = 0; _key < _len; _key++) {
					ids[_key] = arguments[_key];
				}

				var anims;
				return _regenerator2.default.wrap(function _callee12$(_context12) {
					while (1) {
						switch (_context12.prev = _context12.next) {
							case 0:
								_context12.next = 2;
								return this.getAnimations();

							case 2:
								anims = _context12.sent;

								anims.filter(function (anim) {
									return ids.includes(anim.id);
								}).forEach(function (anim) {
									return anim.play();
								});
								return _context12.abrupt('return', this);

							case 5:
							case 'end':
								return _context12.stop();
						}
					}
				}, _callee12, this);
			}));

			function playAnimations() {
				return _ref12.apply(this, arguments);
			}

			return playAnimations;
		}()
	}, {
		key: 'pauseAnimations',
		value: function () {
			var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
				for (var _len2 = arguments.length, ids = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					ids[_key2] = arguments[_key2];
				}

				var anims;
				return _regenerator2.default.wrap(function _callee13$(_context13) {
					while (1) {
						switch (_context13.prev = _context13.next) {
							case 0:
								_context13.next = 2;
								return this.getAnimations();

							case 2:
								anims = _context13.sent;

								anims.filter(function (anim) {
									return ids.includes(anim.id);
								}).forEach(function (anim) {
									return anim.pause();
								});
								return _context13.abrupt('return', this);

							case 5:
							case 'end':
								return _context13.stop();
						}
					}
				}, _callee13, this);
			}));

			function pauseAnimations() {
				return _ref13.apply(this, arguments);
			}

			return pauseAnimations;
		}()
	}, {
		key: 'cancelAnimations',
		value: function () {
			var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
				for (var _len3 = arguments.length, ids = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					ids[_key3] = arguments[_key3];
				}

				var anims;
				return _regenerator2.default.wrap(function _callee14$(_context14) {
					while (1) {
						switch (_context14.prev = _context14.next) {
							case 0:
								_context14.next = 2;
								return this.getAnimations();

							case 2:
								anims = _context14.sent;

								anims.filter(function (anim) {
									return ids.includes(anim.id);
								}).forEach(function (anim) {
									return anim.cancel();
								});
								return _context14.abrupt('return', this);

							case 5:
							case 'end':
								return _context14.stop();
						}
					}
				}, _callee14, this);
			}));

			function cancelAnimations() {
				return _ref14.apply(this, arguments);
			}

			return cancelAnimations;
		}()
	}, {
		key: 'animateFilter',
		value: function () {
			var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
				var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref16$duration = _ref16.duration,
				    duration = _ref16$duration === undefined ? 400 : _ref16$duration,
				    _ref16$delay = _ref16.delay,
				    delay = _ref16$delay === undefined ? 0 : _ref16$delay,
				    _ref16$fill = _ref16.fill,
				    fill = _ref16$fill === undefined ? 'both' : _ref16$fill,
				    _ref16$direction = _ref16.direction,
				    direction = _ref16$direction === undefined ? 'normal' : _ref16$direction,
				    _ref16$easing = _ref16.easing,
				    easing = _ref16$easing === undefined ? 'linear' : _ref16$easing,
				    _ref16$iterations = _ref16.iterations,
				    iterations = _ref16$iterations === undefined ? 1 : _ref16$iterations,
				    _ref16$from = _ref16.from,
				    from = _ref16$from === undefined ? 'none' : _ref16$from,
				    _ref16$to = _ref16.to,
				    to = _ref16$to === undefined ? 'none' : _ref16$to,
				    _ref16$id = _ref16.id,
				    id = _ref16$id === undefined ? 'grayscale' : _ref16$id;

				return _regenerator2.default.wrap(function _callee15$(_context15) {
					while (1) {
						switch (_context15.prev = _context15.next) {
							case 0:
								return _context15.abrupt('return', this.animate([{ filter: '' + from }, { filter: '' + to }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context15.stop();
						}
					}
				}, _callee15, this);
			}));

			function animateFilter() {
				return _ref15.apply(this, arguments);
			}

			return animateFilter;
		}()
	}, {
		key: 'filterDropShadow',
		value: function () {
			var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
				var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref18$duration = _ref18.duration,
				    duration = _ref18$duration === undefined ? 400 : _ref18$duration,
				    _ref18$delay = _ref18.delay,
				    delay = _ref18$delay === undefined ? 0 : _ref18$delay,
				    _ref18$fill = _ref18.fill,
				    fill = _ref18$fill === undefined ? 'both' : _ref18$fill,
				    _ref18$direction = _ref18.direction,
				    direction = _ref18$direction === undefined ? 'normal' : _ref18$direction,
				    _ref18$easing = _ref18.easing,
				    easing = _ref18$easing === undefined ? 'linear' : _ref18$easing,
				    _ref18$iterations = _ref18.iterations,
				    iterations = _ref18$iterations === undefined ? 1 : _ref18$iterations,
				    _ref18$from = _ref18.from,
				    from = _ref18$from === undefined ? '0 0 0 black' : _ref18$from,
				    _ref18$to = _ref18.to,
				    to = _ref18$to === undefined ? '0.5em 0.5em 0.5em rgba(0,0,0,0.3)' : _ref18$to,
				    _ref18$id = _ref18.id,
				    id = _ref18$id === undefined ? 'drop-shadow' : _ref18$id;

				return _regenerator2.default.wrap(function _callee16$(_context16) {
					while (1) {
						switch (_context16.prev = _context16.next) {
							case 0:
								return _context16.abrupt('return', this.animate([{ filter: 'drop-shadow(' + from + ')' }, { filter: 'drop-shadow(' + to + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context16.stop();
						}
					}
				}, _callee16, this);
			}));

			function filterDropShadow() {
				return _ref17.apply(this, arguments);
			}

			return filterDropShadow;
		}()
	}, {
		key: 'filterGrayscale',
		value: function () {
			var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17() {
				var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref20$duration = _ref20.duration,
				    duration = _ref20$duration === undefined ? 400 : _ref20$duration,
				    _ref20$delay = _ref20.delay,
				    delay = _ref20$delay === undefined ? 0 : _ref20$delay,
				    _ref20$fill = _ref20.fill,
				    fill = _ref20$fill === undefined ? 'both' : _ref20$fill,
				    _ref20$direction = _ref20.direction,
				    direction = _ref20$direction === undefined ? 'normal' : _ref20$direction,
				    _ref20$easing = _ref20.easing,
				    easing = _ref20$easing === undefined ? 'linear' : _ref20$easing,
				    _ref20$iterations = _ref20.iterations,
				    iterations = _ref20$iterations === undefined ? 1 : _ref20$iterations,
				    _ref20$from = _ref20.from,
				    from = _ref20$from === undefined ? 0 : _ref20$from,
				    _ref20$to = _ref20.to,
				    to = _ref20$to === undefined ? 1 : _ref20$to,
				    _ref20$id = _ref20.id,
				    id = _ref20$id === undefined ? 'grayscale' : _ref20$id;

				return _regenerator2.default.wrap(function _callee17$(_context17) {
					while (1) {
						switch (_context17.prev = _context17.next) {
							case 0:
								return _context17.abrupt('return', this.animateFilter({
									from: 'grayscale(' + from + ')',
									to: 'grayscale(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context17.stop();
						}
					}
				}, _callee17, this);
			}));

			function filterGrayscale() {
				return _ref19.apply(this, arguments);
			}

			return filterGrayscale;
		}()
	}, {
		key: 'filterBlur',
		value: function () {
			var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18() {
				var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref22$duration = _ref22.duration,
				    duration = _ref22$duration === undefined ? 400 : _ref22$duration,
				    _ref22$delay = _ref22.delay,
				    delay = _ref22$delay === undefined ? 0 : _ref22$delay,
				    _ref22$fill = _ref22.fill,
				    fill = _ref22$fill === undefined ? 'both' : _ref22$fill,
				    _ref22$direction = _ref22.direction,
				    direction = _ref22$direction === undefined ? 'normal' : _ref22$direction,
				    _ref22$easing = _ref22.easing,
				    easing = _ref22$easing === undefined ? 'linear' : _ref22$easing,
				    _ref22$iterations = _ref22.iterations,
				    iterations = _ref22$iterations === undefined ? 1 : _ref22$iterations,
				    _ref22$from = _ref22.from,
				    from = _ref22$from === undefined ? '0px' : _ref22$from,
				    _ref22$to = _ref22.to,
				    to = _ref22$to === undefined ? '5px' : _ref22$to,
				    _ref22$id = _ref22.id,
				    id = _ref22$id === undefined ? 'blur' : _ref22$id;

				return _regenerator2.default.wrap(function _callee18$(_context18) {
					while (1) {
						switch (_context18.prev = _context18.next) {
							case 0:
								return _context18.abrupt('return', this.animateFilter({
									from: 'blur(' + from + ')',
									to: 'blur(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context18.stop();
						}
					}
				}, _callee18, this);
			}));

			function filterBlur() {
				return _ref21.apply(this, arguments);
			}

			return filterBlur;
		}()
	}, {
		key: 'filterInvert',
		value: function () {
			var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19() {
				var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref24$duration = _ref24.duration,
				    duration = _ref24$duration === undefined ? 400 : _ref24$duration,
				    _ref24$delay = _ref24.delay,
				    delay = _ref24$delay === undefined ? 0 : _ref24$delay,
				    _ref24$fill = _ref24.fill,
				    fill = _ref24$fill === undefined ? 'both' : _ref24$fill,
				    _ref24$direction = _ref24.direction,
				    direction = _ref24$direction === undefined ? 'normal' : _ref24$direction,
				    _ref24$easing = _ref24.easing,
				    easing = _ref24$easing === undefined ? 'linear' : _ref24$easing,
				    _ref24$iterations = _ref24.iterations,
				    iterations = _ref24$iterations === undefined ? 1 : _ref24$iterations,
				    _ref24$from = _ref24.from,
				    from = _ref24$from === undefined ? 0 : _ref24$from,
				    _ref24$to = _ref24.to,
				    to = _ref24$to === undefined ? '100%' : _ref24$to,
				    _ref24$id = _ref24.id,
				    id = _ref24$id === undefined ? 'invert' : _ref24$id;

				return _regenerator2.default.wrap(function _callee19$(_context19) {
					while (1) {
						switch (_context19.prev = _context19.next) {
							case 0:
								return _context19.abrupt('return', this.animateFilter({
									from: 'invert(' + from + ')',
									to: 'invert(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context19.stop();
						}
					}
				}, _callee19, this);
			}));

			function filterInvert() {
				return _ref23.apply(this, arguments);
			}

			return filterInvert;
		}()
	}, {
		key: 'filterHueRotate',
		value: function () {
			var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20() {
				var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref26$duration = _ref26.duration,
				    duration = _ref26$duration === undefined ? 400 : _ref26$duration,
				    _ref26$delay = _ref26.delay,
				    delay = _ref26$delay === undefined ? 0 : _ref26$delay,
				    _ref26$fill = _ref26.fill,
				    fill = _ref26$fill === undefined ? 'both' : _ref26$fill,
				    _ref26$direction = _ref26.direction,
				    direction = _ref26$direction === undefined ? 'normal' : _ref26$direction,
				    _ref26$easing = _ref26.easing,
				    easing = _ref26$easing === undefined ? 'linear' : _ref26$easing,
				    _ref26$iterations = _ref26.iterations,
				    iterations = _ref26$iterations === undefined ? 1 : _ref26$iterations,
				    _ref26$from = _ref26.from,
				    from = _ref26$from === undefined ? '0deg' : _ref26$from,
				    _ref26$to = _ref26.to,
				    to = _ref26$to === undefined ? '90deg' : _ref26$to,
				    _ref26$id = _ref26.id,
				    id = _ref26$id === undefined ? 'hue-rotate' : _ref26$id;

				return _regenerator2.default.wrap(function _callee20$(_context20) {
					while (1) {
						switch (_context20.prev = _context20.next) {
							case 0:
								return _context20.abrupt('return', this.animateFilter({
									from: 'hue-rotate(' + from + ')',
									to: 'hue-rotate(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context20.stop();
						}
					}
				}, _callee20, this);
			}));

			function filterHueRotate() {
				return _ref25.apply(this, arguments);
			}

			return filterHueRotate;
		}()
	}, {
		key: 'filterBrightness',
		value: function () {
			var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21() {
				var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref28$duration = _ref28.duration,
				    duration = _ref28$duration === undefined ? 400 : _ref28$duration,
				    _ref28$delay = _ref28.delay,
				    delay = _ref28$delay === undefined ? 0 : _ref28$delay,
				    _ref28$fill = _ref28.fill,
				    fill = _ref28$fill === undefined ? 'both' : _ref28$fill,
				    _ref28$direction = _ref28.direction,
				    direction = _ref28$direction === undefined ? 'normal' : _ref28$direction,
				    _ref28$easing = _ref28.easing,
				    easing = _ref28$easing === undefined ? 'linear' : _ref28$easing,
				    _ref28$iterations = _ref28.iterations,
				    iterations = _ref28$iterations === undefined ? 1 : _ref28$iterations,
				    _ref28$from = _ref28.from,
				    from = _ref28$from === undefined ? 0 : _ref28$from,
				    _ref28$to = _ref28.to,
				    to = _ref28$to === undefined ? 1 : _ref28$to,
				    _ref28$id = _ref28.id,
				    id = _ref28$id === undefined ? 'brightness' : _ref28$id;

				return _regenerator2.default.wrap(function _callee21$(_context21) {
					while (1) {
						switch (_context21.prev = _context21.next) {
							case 0:
								return _context21.abrupt('return', this.animateFilter({
									from: 'brightness(' + from + ')',
									to: 'brightness(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context21.stop();
						}
					}
				}, _callee21, this);
			}));

			function filterBrightness() {
				return _ref27.apply(this, arguments);
			}

			return filterBrightness;
		}()
	}, {
		key: 'filterContrast',
		value: function () {
			var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22() {
				var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref30$duration = _ref30.duration,
				    duration = _ref30$duration === undefined ? 400 : _ref30$duration,
				    _ref30$delay = _ref30.delay,
				    delay = _ref30$delay === undefined ? 0 : _ref30$delay,
				    _ref30$fill = _ref30.fill,
				    fill = _ref30$fill === undefined ? 'both' : _ref30$fill,
				    _ref30$direction = _ref30.direction,
				    direction = _ref30$direction === undefined ? 'normal' : _ref30$direction,
				    _ref30$easing = _ref30.easing,
				    easing = _ref30$easing === undefined ? 'linear' : _ref30$easing,
				    _ref30$iterations = _ref30.iterations,
				    iterations = _ref30$iterations === undefined ? 1 : _ref30$iterations,
				    _ref30$from = _ref30.from,
				    from = _ref30$from === undefined ? 0 : _ref30$from,
				    _ref30$to = _ref30.to,
				    to = _ref30$to === undefined ? 1 : _ref30$to,
				    _ref30$id = _ref30.id,
				    id = _ref30$id === undefined ? 'contrast' : _ref30$id;

				return _regenerator2.default.wrap(function _callee22$(_context22) {
					while (1) {
						switch (_context22.prev = _context22.next) {
							case 0:
								return _context22.abrupt('return', this.animateFilter({
									from: 'contrast(' + from + ')',
									to: 'contrast(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context22.stop();
						}
					}
				}, _callee22, this);
			}));

			function filterContrast() {
				return _ref29.apply(this, arguments);
			}

			return filterContrast;
		}()
	}, {
		key: 'filterSaturate',
		value: function () {
			var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23() {
				var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref32$duration = _ref32.duration,
				    duration = _ref32$duration === undefined ? 400 : _ref32$duration,
				    _ref32$delay = _ref32.delay,
				    delay = _ref32$delay === undefined ? 0 : _ref32$delay,
				    _ref32$fill = _ref32.fill,
				    fill = _ref32$fill === undefined ? 'both' : _ref32$fill,
				    _ref32$direction = _ref32.direction,
				    direction = _ref32$direction === undefined ? 'normal' : _ref32$direction,
				    _ref32$easing = _ref32.easing,
				    easing = _ref32$easing === undefined ? 'linear' : _ref32$easing,
				    _ref32$iterations = _ref32.iterations,
				    iterations = _ref32$iterations === undefined ? 1 : _ref32$iterations,
				    _ref32$from = _ref32.from,
				    from = _ref32$from === undefined ? 0 : _ref32$from,
				    _ref32$to = _ref32.to,
				    to = _ref32$to === undefined ? 1 : _ref32$to,
				    _ref32$id = _ref32.id,
				    id = _ref32$id === undefined ? 'saturate' : _ref32$id;

				return _regenerator2.default.wrap(function _callee23$(_context23) {
					while (1) {
						switch (_context23.prev = _context23.next) {
							case 0:
								return _context23.abrupt('return', this.animateFilter({
									from: 'saturate(' + from + ')',
									to: 'saturate(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context23.stop();
						}
					}
				}, _callee23, this);
			}));

			function filterSaturate() {
				return _ref31.apply(this, arguments);
			}

			return filterSaturate;
		}()
	}, {
		key: 'filterOpacity',
		value: function () {
			var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24() {
				var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref34$duration = _ref34.duration,
				    duration = _ref34$duration === undefined ? 400 : _ref34$duration,
				    _ref34$delay = _ref34.delay,
				    delay = _ref34$delay === undefined ? 0 : _ref34$delay,
				    _ref34$fill = _ref34.fill,
				    fill = _ref34$fill === undefined ? 'both' : _ref34$fill,
				    _ref34$direction = _ref34.direction,
				    direction = _ref34$direction === undefined ? 'normal' : _ref34$direction,
				    _ref34$easing = _ref34.easing,
				    easing = _ref34$easing === undefined ? 'linear' : _ref34$easing,
				    _ref34$iterations = _ref34.iterations,
				    iterations = _ref34$iterations === undefined ? 1 : _ref34$iterations,
				    _ref34$from = _ref34.from,
				    from = _ref34$from === undefined ? 0 : _ref34$from,
				    _ref34$to = _ref34.to,
				    to = _ref34$to === undefined ? 1 : _ref34$to,
				    _ref34$id = _ref34.id,
				    id = _ref34$id === undefined ? 'saturate' : _ref34$id;

				return _regenerator2.default.wrap(function _callee24$(_context24) {
					while (1) {
						switch (_context24.prev = _context24.next) {
							case 0:
								return _context24.abrupt('return', this.animateFilter({
									from: 'opacity(' + from + ')',
									to: 'opacity(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context24.stop();
						}
					}
				}, _callee24, this);
			}));

			function filterOpacity() {
				return _ref33.apply(this, arguments);
			}

			return filterOpacity;
		}()
	}, {
		key: 'filterSepia',
		value: function () {
			var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25() {
				var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref36$duration = _ref36.duration,
				    duration = _ref36$duration === undefined ? 400 : _ref36$duration,
				    _ref36$delay = _ref36.delay,
				    delay = _ref36$delay === undefined ? 0 : _ref36$delay,
				    _ref36$fill = _ref36.fill,
				    fill = _ref36$fill === undefined ? 'both' : _ref36$fill,
				    _ref36$direction = _ref36.direction,
				    direction = _ref36$direction === undefined ? 'normal' : _ref36$direction,
				    _ref36$easing = _ref36.easing,
				    easing = _ref36$easing === undefined ? 'linear' : _ref36$easing,
				    _ref36$iterations = _ref36.iterations,
				    iterations = _ref36$iterations === undefined ? 1 : _ref36$iterations,
				    _ref36$from = _ref36.from,
				    from = _ref36$from === undefined ? 0 : _ref36$from,
				    _ref36$to = _ref36.to,
				    to = _ref36$to === undefined ? 1 : _ref36$to,
				    _ref36$id = _ref36.id,
				    id = _ref36$id === undefined ? 'sepia' : _ref36$id;

				return _regenerator2.default.wrap(function _callee25$(_context25) {
					while (1) {
						switch (_context25.prev = _context25.next) {
							case 0:
								return _context25.abrupt('return', this.animateFilter({
									from: 'sepia(' + from + ')',
									to: 'sepia(' + to + ')',
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context25.stop();
						}
					}
				}, _callee25, this);
			}));

			function filterSepia() {
				return _ref35.apply(this, arguments);
			}

			return filterSepia;
		}()
	}, {
		key: 'fade',
		value: function () {
			var _ref37 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26() {
				var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref38$duration = _ref38.duration,
				    duration = _ref38$duration === undefined ? 400 : _ref38$duration,
				    _ref38$delay = _ref38.delay,
				    delay = _ref38$delay === undefined ? 0 : _ref38$delay,
				    _ref38$fill = _ref38.fill,
				    fill = _ref38$fill === undefined ? 'forwards' : _ref38$fill,
				    _ref38$direction = _ref38.direction,
				    direction = _ref38$direction === undefined ? 'normal' : _ref38$direction,
				    _ref38$easing = _ref38.easing,
				    easing = _ref38$easing === undefined ? 'linear' : _ref38$easing,
				    _ref38$iterations = _ref38.iterations,
				    iterations = _ref38$iterations === undefined ? 1 : _ref38$iterations,
				    _ref38$from = _ref38.from,
				    from = _ref38$from === undefined ? 1 : _ref38$from,
				    _ref38$to = _ref38.to,
				    to = _ref38$to === undefined ? 0 : _ref38$to,
				    _ref38$id = _ref38.id,
				    id = _ref38$id === undefined ? 'fade-in' : _ref38$id;

				return _regenerator2.default.wrap(function _callee26$(_context26) {
					while (1) {
						switch (_context26.prev = _context26.next) {
							case 0:
								return _context26.abrupt('return', this.animate([{ opacity: from }, { opacity: to }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context26.stop();
						}
					}
				}, _callee26, this);
			}));

			function fade() {
				return _ref37.apply(this, arguments);
			}

			return fade;
		}()
	}, {
		key: 'fadeIn',
		value: function () {
			var _ref39 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27() {
				var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref40$duration = _ref40.duration,
				    duration = _ref40$duration === undefined ? 400 : _ref40$duration,
				    _ref40$delay = _ref40.delay,
				    delay = _ref40$delay === undefined ? 0 : _ref40$delay,
				    _ref40$fill = _ref40.fill,
				    fill = _ref40$fill === undefined ? 'forwards' : _ref40$fill,
				    _ref40$direction = _ref40.direction,
				    direction = _ref40$direction === undefined ? 'normal' : _ref40$direction,
				    _ref40$easing = _ref40.easing,
				    easing = _ref40$easing === undefined ? 'linear' : _ref40$easing,
				    _ref40$iterations = _ref40.iterations,
				    iterations = _ref40$iterations === undefined ? 1 : _ref40$iterations,
				    _ref40$from = _ref40.from,
				    from = _ref40$from === undefined ? 0 : _ref40$from,
				    _ref40$to = _ref40.to,
				    to = _ref40$to === undefined ? 1 : _ref40$to,
				    _ref40$id = _ref40.id,
				    id = _ref40$id === undefined ? 'fade-in' : _ref40$id;

				return _regenerator2.default.wrap(function _callee27$(_context27) {
					while (1) {
						switch (_context27.prev = _context27.next) {
							case 0:
								return _context27.abrupt('return', this.fade({
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									from: from,
									to: to,
									id: id
								}));

							case 1:
							case 'end':
								return _context27.stop();
						}
					}
				}, _callee27, this);
			}));

			function fadeIn() {
				return _ref39.apply(this, arguments);
			}

			return fadeIn;
		}()
	}, {
		key: 'fadeOut',
		value: function () {
			var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28() {
				var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				return _regenerator2.default.wrap(function _callee28$(_context28) {
					while (1) {
						switch (_context28.prev = _context28.next) {
							case 0:
								return _context28.abrupt('return', this.fade(opts));

							case 1:
							case 'end':
								return _context28.stop();
						}
					}
				}, _callee28, this);
			}));

			function fadeOut() {
				return _ref41.apply(this, arguments);
			}

			return fadeOut;
		}()
	}, {
		key: 'scale',
		value: function () {
			var _ref42 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29() {
				var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref43$duration = _ref43.duration,
				    duration = _ref43$duration === undefined ? 400 : _ref43$duration,
				    _ref43$delay = _ref43.delay,
				    delay = _ref43$delay === undefined ? 0 : _ref43$delay,
				    _ref43$fill = _ref43.fill,
				    fill = _ref43$fill === undefined ? 'both' : _ref43$fill,
				    _ref43$direction = _ref43.direction,
				    direction = _ref43$direction === undefined ? 'normal' : _ref43$direction,
				    _ref43$easing = _ref43.easing,
				    easing = _ref43$easing === undefined ? 'linear' : _ref43$easing,
				    _ref43$iterations = _ref43.iterations,
				    iterations = _ref43$iterations === undefined ? 1 : _ref43$iterations,
				    _ref43$id = _ref43.id,
				    id = _ref43$id === undefined ? 'scale' : _ref43$id,
				    _ref43$initialScale = _ref43.initialScale,
				    initialScale = _ref43$initialScale === undefined ? 0 : _ref43$initialScale,
				    _ref43$scale = _ref43.scale,
				    _scale = _ref43$scale === undefined ? 1.5 : _ref43$scale;

				return _regenerator2.default.wrap(function _callee29$(_context29) {
					while (1) {
						switch (_context29.prev = _context29.next) {
							case 0:
								return _context29.abrupt('return', this.animate([{ transform: 'scale(' + initialScale + ')' }, { transform: 'scale(' + _scale + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context29.stop();
						}
					}
				}, _callee29, this);
			}));

			function scale() {
				return _ref42.apply(this, arguments);
			}

			return scale;
		}()
	}, {
		key: 'grow',
		value: function () {
			var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30() {
				var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref45$duration = _ref45.duration,
				    duration = _ref45$duration === undefined ? 400 : _ref45$duration,
				    _ref45$delay = _ref45.delay,
				    delay = _ref45$delay === undefined ? 0 : _ref45$delay,
				    _ref45$fill = _ref45.fill,
				    fill = _ref45$fill === undefined ? 'both' : _ref45$fill,
				    _ref45$direction = _ref45.direction,
				    direction = _ref45$direction === undefined ? 'normal' : _ref45$direction,
				    _ref45$easing = _ref45.easing,
				    easing = _ref45$easing === undefined ? 'linear' : _ref45$easing,
				    _ref45$iterations = _ref45.iterations,
				    iterations = _ref45$iterations === undefined ? 1 : _ref45$iterations,
				    _ref45$id = _ref45.id,
				    id = _ref45$id === undefined ? 'grow' : _ref45$id,
				    _ref45$initialScale = _ref45.initialScale,
				    initialScale = _ref45$initialScale === undefined ? 0 : _ref45$initialScale,
				    _ref45$scale = _ref45.scale,
				    scale = _ref45$scale === undefined ? 1 : _ref45$scale;

				return _regenerator2.default.wrap(function _callee30$(_context30) {
					while (1) {
						switch (_context30.prev = _context30.next) {
							case 0:
								return _context30.abrupt('return', this.scale({
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id,
									scale: scale,
									initialScale: initialScale
								}));

							case 1:
							case 'end':
								return _context30.stop();
						}
					}
				}, _callee30, this);
			}));

			function grow() {
				return _ref44.apply(this, arguments);
			}

			return grow;
		}()
	}, {
		key: 'shrink',
		value: function () {
			var _ref46 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31() {
				var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref47$duration = _ref47.duration,
				    duration = _ref47$duration === undefined ? 400 : _ref47$duration,
				    _ref47$delay = _ref47.delay,
				    delay = _ref47$delay === undefined ? 0 : _ref47$delay,
				    _ref47$fill = _ref47.fill,
				    fill = _ref47$fill === undefined ? 'both' : _ref47$fill,
				    _ref47$direction = _ref47.direction,
				    direction = _ref47$direction === undefined ? 'normal' : _ref47$direction,
				    _ref47$easing = _ref47.easing,
				    easing = _ref47$easing === undefined ? 'linear' : _ref47$easing,
				    _ref47$iterations = _ref47.iterations,
				    iterations = _ref47$iterations === undefined ? 1 : _ref47$iterations,
				    _ref47$id = _ref47.id,
				    id = _ref47$id === undefined ? 'shrink' : _ref47$id,
				    _ref47$initialScale = _ref47.initialScale,
				    initialScale = _ref47$initialScale === undefined ? 1 : _ref47$initialScale,
				    _ref47$scale = _ref47.scale,
				    scale = _ref47$scale === undefined ? 0 : _ref47$scale;

				return _regenerator2.default.wrap(function _callee31$(_context31) {
					while (1) {
						switch (_context31.prev = _context31.next) {
							case 0:
								return _context31.abrupt('return', this.scale({
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id,
									scale: scale,
									initialScale: initialScale
								}));

							case 1:
							case 'end':
								return _context31.stop();
						}
					}
				}, _callee31, this);
			}));

			function shrink() {
				return _ref46.apply(this, arguments);
			}

			return shrink;
		}()
	}, {
		key: 'rotate',
		value: function () {
			var _ref48 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32() {
				var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref49$duration = _ref49.duration,
				    duration = _ref49$duration === undefined ? 400 : _ref49$duration,
				    _ref49$delay = _ref49.delay,
				    delay = _ref49$delay === undefined ? 0 : _ref49$delay,
				    _ref49$fill = _ref49.fill,
				    fill = _ref49$fill === undefined ? 'both' : _ref49$fill,
				    _ref49$direction = _ref49.direction,
				    direction = _ref49$direction === undefined ? 'normal' : _ref49$direction,
				    _ref49$easing = _ref49.easing,
				    easing = _ref49$easing === undefined ? 'linear' : _ref49$easing,
				    _ref49$iterations = _ref49.iterations,
				    iterations = _ref49$iterations === undefined ? 1 : _ref49$iterations,
				    _ref49$id = _ref49.id,
				    id = _ref49$id === undefined ? 'rotate' : _ref49$id,
				    _ref49$rotation = _ref49.rotation,
				    rotation = _ref49$rotation === undefined ? '1turn' : _ref49$rotation,
				    _ref49$initialRotatio = _ref49.initialRotation,
				    initialRotation = _ref49$initialRotatio === undefined ? '0turn' : _ref49$initialRotatio;

				return _regenerator2.default.wrap(function _callee32$(_context32) {
					while (1) {
						switch (_context32.prev = _context32.next) {
							case 0:
								return _context32.abrupt('return', this.animate([{ transform: 'rotate(' + initialRotation + ')' }, { transform: 'rotate(' + rotation + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context32.stop();
						}
					}
				}, _callee32, this);
			}));

			function rotate() {
				return _ref48.apply(this, arguments);
			}

			return rotate;
		}()
	}, {
		key: 'bounce',
		value: function () {
			var _ref50 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33() {
				var _ref51 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref51$duration = _ref51.duration,
				    duration = _ref51$duration === undefined ? 400 : _ref51$duration,
				    _ref51$delay = _ref51.delay,
				    delay = _ref51$delay === undefined ? 0 : _ref51$delay,
				    _ref51$fill = _ref51.fill,
				    fill = _ref51$fill === undefined ? 'none' : _ref51$fill,
				    _ref51$direction = _ref51.direction,
				    direction = _ref51$direction === undefined ? 'alternate' : _ref51$direction,
				    _ref51$easing = _ref51.easing,
				    easing = _ref51$easing === undefined ? 'ease-in-out' : _ref51$easing,
				    _ref51$iterations = _ref51.iterations,
				    iterations = _ref51$iterations === undefined ? 1 : _ref51$iterations,
				    _ref51$id = _ref51.id,
				    id = _ref51$id === undefined ? 'bounce' : _ref51$id,
				    _ref51$height = _ref51.height,
				    height = _ref51$height === undefined ? '-50px' : _ref51$height;

				return _regenerator2.default.wrap(function _callee33$(_context33) {
					while (1) {
						switch (_context33.prev = _context33.next) {
							case 0:
								return _context33.abrupt('return', this.animate([{ transform: 'none' }, { transform: 'translateY(' + height + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context33.stop();
						}
					}
				}, _callee33, this);
			}));

			function bounce() {
				return _ref50.apply(this, arguments);
			}

			return bounce;
		}()
	}, {
		key: 'shake',
		value: function () {
			var _ref52 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34() {
				var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref53$duration = _ref53.duration,
				    duration = _ref53$duration === undefined ? 400 : _ref53$duration,
				    _ref53$delay = _ref53.delay,
				    delay = _ref53$delay === undefined ? 0 : _ref53$delay,
				    _ref53$fill = _ref53.fill,
				    fill = _ref53$fill === undefined ? 'none' : _ref53$fill,
				    _ref53$direction = _ref53.direction,
				    direction = _ref53$direction === undefined ? 'alternate' : _ref53$direction,
				    _ref53$easing = _ref53.easing,
				    easing = _ref53$easing === undefined ? 'cubic-bezier(.68,-0.55,.27,1.55)' : _ref53$easing,
				    _ref53$iterations = _ref53.iterations,
				    iterations = _ref53$iterations === undefined ? 6 : _ref53$iterations,
				    _ref53$id = _ref53.id,
				    id = _ref53$id === undefined ? 'shake' : _ref53$id,
				    _ref53$offsetX = _ref53.offsetX,
				    offsetX = _ref53$offsetX === undefined ? '60px' : _ref53$offsetX,
				    _ref53$offsetY = _ref53.offsetY,
				    offsetY = _ref53$offsetY === undefined ? '20px' : _ref53$offsetY,
				    _ref53$scale = _ref53.scale,
				    scale = _ref53$scale === undefined ? 0.9 : _ref53$scale;

				return _regenerator2.default.wrap(function _callee34$(_context34) {
					while (1) {
						switch (_context34.prev = _context34.next) {
							case 0:
								return _context34.abrupt('return', this.animate([{ transform: 'none' }, { transform: 'translateY(' + offsetY + ') translateX(-' + offsetX + ') scale(' + scale + ')' }, { transform: 'none' }, { transform: 'translateY(-' + offsetY + ') translateX(' + offsetX + ') scale(' + 1 / scale + ')' }, { transform: 'none' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context34.stop();
						}
					}
				}, _callee34, this);
			}));

			function shake() {
				return _ref52.apply(this, arguments);
			}

			return shake;
		}()
	}, {
		key: 'slideLeft',
		value: function () {
			var _ref54 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35() {
				var _ref55 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref55$duration = _ref55.duration,
				    duration = _ref55$duration === undefined ? 400 : _ref55$duration,
				    _ref55$delay = _ref55.delay,
				    delay = _ref55$delay === undefined ? 0 : _ref55$delay,
				    _ref55$fill = _ref55.fill,
				    fill = _ref55$fill === undefined ? 'forwards' : _ref55$fill,
				    _ref55$direction = _ref55.direction,
				    direction = _ref55$direction === undefined ? 'normal' : _ref55$direction,
				    _ref55$easing = _ref55.easing,
				    easing = _ref55$easing === undefined ? 'ease-in' : _ref55$easing,
				    _ref55$iterations = _ref55.iterations,
				    iterations = _ref55$iterations === undefined ? 1 : _ref55$iterations,
				    _ref55$id = _ref55.id,
				    id = _ref55$id === undefined ? 'slide-left' : _ref55$id,
				    _ref55$initial = _ref55.initial,
				    initial = _ref55$initial === undefined ? 0 : _ref55$initial,
				    _ref55$distance = _ref55.distance,
				    distance = _ref55$distance === undefined ? '50px' : _ref55$distance;

				return _regenerator2.default.wrap(function _callee35$(_context35) {
					while (1) {
						switch (_context35.prev = _context35.next) {
							case 0:
								return _context35.abrupt('return', this.animate([{ transform: 'translateX(' + initial + ')' }, { transform: 'translateX(-' + distance + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context35.stop();
						}
					}
				}, _callee35, this);
			}));

			function slideLeft() {
				return _ref54.apply(this, arguments);
			}

			return slideLeft;
		}()
	}, {
		key: 'slideRight',
		value: function () {
			var _ref56 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36() {
				var _ref57 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref57$duration = _ref57.duration,
				    duration = _ref57$duration === undefined ? 400 : _ref57$duration,
				    _ref57$delay = _ref57.delay,
				    delay = _ref57$delay === undefined ? 0 : _ref57$delay,
				    _ref57$fill = _ref57.fill,
				    fill = _ref57$fill === undefined ? 'forwards' : _ref57$fill,
				    _ref57$direction = _ref57.direction,
				    direction = _ref57$direction === undefined ? 'normal' : _ref57$direction,
				    _ref57$easing = _ref57.easing,
				    easing = _ref57$easing === undefined ? 'ease-in' : _ref57$easing,
				    _ref57$iterations = _ref57.iterations,
				    iterations = _ref57$iterations === undefined ? 1 : _ref57$iterations,
				    _ref57$id = _ref57.id,
				    id = _ref57$id === undefined ? 'slide-right' : _ref57$id,
				    _ref57$initial = _ref57.initial,
				    initial = _ref57$initial === undefined ? 0 : _ref57$initial,
				    _ref57$distance = _ref57.distance,
				    distance = _ref57$distance === undefined ? '50px' : _ref57$distance;

				return _regenerator2.default.wrap(function _callee36$(_context36) {
					while (1) {
						switch (_context36.prev = _context36.next) {
							case 0:
								return _context36.abrupt('return', this.animate([{ transform: 'translateX(' + initial + ')' }, { transform: 'translateX(' + distance + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context36.stop();
						}
					}
				}, _callee36, this);
			}));

			function slideRight() {
				return _ref56.apply(this, arguments);
			}

			return slideRight;
		}()
	}, {
		key: 'slideUp',
		value: function () {
			var _ref58 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee37() {
				var _ref59 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref59$duration = _ref59.duration,
				    duration = _ref59$duration === undefined ? 400 : _ref59$duration,
				    _ref59$delay = _ref59.delay,
				    delay = _ref59$delay === undefined ? 0 : _ref59$delay,
				    _ref59$fill = _ref59.fill,
				    fill = _ref59$fill === undefined ? 'forwards' : _ref59$fill,
				    _ref59$direction = _ref59.direction,
				    direction = _ref59$direction === undefined ? 'normal' : _ref59$direction,
				    _ref59$easing = _ref59.easing,
				    easing = _ref59$easing === undefined ? 'ease-in' : _ref59$easing,
				    _ref59$iterations = _ref59.iterations,
				    iterations = _ref59$iterations === undefined ? 1 : _ref59$iterations,
				    _ref59$id = _ref59.id,
				    id = _ref59$id === undefined ? 'slide-up' : _ref59$id,
				    _ref59$initial = _ref59.initial,
				    initial = _ref59$initial === undefined ? 0 : _ref59$initial,
				    _ref59$distance = _ref59.distance,
				    distance = _ref59$distance === undefined ? '50px' : _ref59$distance;

				return _regenerator2.default.wrap(function _callee37$(_context37) {
					while (1) {
						switch (_context37.prev = _context37.next) {
							case 0:
								return _context37.abrupt('return', this.animate([{ transform: 'translateY(' + initial + ')' }, { transform: 'translateY(-' + distance + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context37.stop();
						}
					}
				}, _callee37, this);
			}));

			function slideUp() {
				return _ref58.apply(this, arguments);
			}

			return slideUp;
		}()
	}, {
		key: 'slideDown',
		value: function () {
			var _ref60 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee38() {
				var _ref61 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref61$duration = _ref61.duration,
				    duration = _ref61$duration === undefined ? 400 : _ref61$duration,
				    _ref61$delay = _ref61.delay,
				    delay = _ref61$delay === undefined ? 0 : _ref61$delay,
				    _ref61$fill = _ref61.fill,
				    fill = _ref61$fill === undefined ? 'forwards' : _ref61$fill,
				    _ref61$direction = _ref61.direction,
				    direction = _ref61$direction === undefined ? 'normal' : _ref61$direction,
				    _ref61$easing = _ref61.easing,
				    easing = _ref61$easing === undefined ? 'ease-in' : _ref61$easing,
				    _ref61$iterations = _ref61.iterations,
				    iterations = _ref61$iterations === undefined ? 1 : _ref61$iterations,
				    _ref61$id = _ref61.id,
				    id = _ref61$id === undefined ? 'slide-down' : _ref61$id,
				    _ref61$initial = _ref61.initial,
				    initial = _ref61$initial === undefined ? 0 : _ref61$initial,
				    _ref61$distance = _ref61.distance,
				    distance = _ref61$distance === undefined ? '50px' : _ref61$distance;

				return _regenerator2.default.wrap(function _callee38$(_context38) {
					while (1) {
						switch (_context38.prev = _context38.next) {
							case 0:
								return _context38.abrupt('return', this.animate([{ transform: 'translateY(' + initial + ')' }, { transform: 'translateY(' + distance + ')' }], {
									delay: delay,
									duration: duration,
									fill: fill,
									easing: easing,
									direction: direction,
									iterations: iterations,
									id: id
								}));

							case 1:
							case 'end':
								return _context38.stop();
						}
					}
				}, _callee38, this);
			}));

			function slideDown() {
				return _ref60.apply(this, arguments);
			}

			return slideDown;
		}()
	}, {
		key: 'loadHTML',
		value: function () {
			var _ref62 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee39(href) {
				var url, resp, parser, html, doc;
				return _regenerator2.default.wrap(function _callee39$(_context39) {
					while (1) {
						switch (_context39.prev = _context39.next) {
							case 0:
								url = new URL(href, location.origin);
								_context39.next = 3;
								return fetch(url);

							case 3:
								resp = _context39.sent;

								if (!resp.ok) {
									_context39.next = 14;
									break;
								}

								parser = new DOMParser();
								_context39.next = 8;
								return resp.text();

							case 8:
								html = _context39.sent;
								doc = parser.parseFromString(html, 'text/html');

								this.html(doc.body.innerHTML);
								return _context39.abrupt('return', this);

							case 14:
								throw new Error(resp.url + ' [' + resp.status + ' ' + resp.statusText + ']');

							case 15:
							case 'end':
								return _context39.stop();
						}
					}
				}, _callee39, this);
			}));

			function loadHTML(_x33) {
				return _ref62.apply(this, arguments);
			}

			return loadHTML;
		}()
	}, {
		key: 'some',
		value: function () {
			var _ref63 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee40(callback) {
				return _regenerator2.default.wrap(function _callee40$(_context40) {
					while (1) {
						switch (_context40.prev = _context40.next) {
							case 0:
								return _context40.abrupt('return', [].concat((0, _toConsumableArray3.default)(this)).some(callback));

							case 1:
							case 'end':
								return _context40.stop();
						}
					}
				}, _callee40, this);
			}));

			function some(_x34) {
				return _ref63.apply(this, arguments);
			}

			return some;
		}()
	}, {
		key: 'every',
		value: function () {
			var _ref64 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee41(callback) {
				return _regenerator2.default.wrap(function _callee41$(_context41) {
					while (1) {
						switch (_context41.prev = _context41.next) {
							case 0:
								return _context41.abrupt('return', [].concat((0, _toConsumableArray3.default)(this)).every(callback));

							case 1:
							case 'end':
								return _context41.stop();
						}
					}
				}, _callee41, this);
			}));

			function every(_x35) {
				return _ref64.apply(this, arguments);
			}

			return every;
		}()
	}, {
		key: 'find',
		value: function () {
			var _ref65 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee42(callback) {
				return _regenerator2.default.wrap(function _callee42$(_context42) {
					while (1) {
						switch (_context42.prev = _context42.next) {
							case 0:
								return _context42.abrupt('return', [].concat((0, _toConsumableArray3.default)(this)).find(callback));

							case 1:
							case 'end':
								return _context42.stop();
						}
					}
				}, _callee42, this);
			}));

			function find(_x36) {
				return _ref65.apply(this, arguments);
			}

			return find;
		}()
	}, {
		key: 'findAll',
		value: function () {
			var _ref66 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee43(callback) {
				return _regenerator2.default.wrap(function _callee43$(_context43) {
					while (1) {
						switch (_context43.prev = _context43.next) {
							case 0:
								return _context43.abrupt('return', this.filter(callback));

							case 1:
							case 'end':
								return _context43.stop();
						}
					}
				}, _callee43, this);
			}));

			function findAll(_x37) {
				return _ref66.apply(this, arguments);
			}

			return findAll;
		}()
	}, {
		key: 'map',
		value: function () {
			var _ref67 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee44(callback) {
				return _regenerator2.default.wrap(function _callee44$(_context44) {
					while (1) {
						switch (_context44.prev = _context44.next) {
							case 0:
								return _context44.abrupt('return', _promise2.default.all([].concat((0, _toConsumableArray3.default)(this)).map(callback)));

							case 1:
							case 'end':
								return _context44.stop();
						}
					}
				}, _callee44, this);
			}));

			function map(_x38) {
				return _ref67.apply(this, arguments);
			}

			return map;
		}()
	}, {
		key: 'filter',
		value: function () {
			var _ref68 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee45(callback) {
				return _regenerator2.default.wrap(function _callee45$(_context45) {
					while (1) {
						switch (_context45.prev = _context45.next) {
							case 0:
								return _context45.abrupt('return', new esQuery([].concat((0, _toConsumableArray3.default)(this)).filter(callback)));

							case 1:
							case 'end':
								return _context45.stop();
						}
					}
				}, _callee45, this);
			}));

			function filter(_x39) {
				return _ref68.apply(this, arguments);
			}

			return filter;
		}()
	}, {
		key: 'addClass',
		value: function () {
			var _ref69 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee46() {
				for (var _len4 = arguments.length, classes = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					classes[_key4] = arguments[_key4];
				}

				return _regenerator2.default.wrap(function _callee46$(_context46) {
					while (1) {
						switch (_context46.prev = _context46.next) {
							case 0:
								this.forEach(function (el) {
									var _el$classList;

									return (_el$classList = el.classList).add.apply(_el$classList, (0, _toConsumableArray3.default)(classes));
								});
								return _context46.abrupt('return', this);

							case 2:
							case 'end':
								return _context46.stop();
						}
					}
				}, _callee46, this);
			}));

			function addClass() {
				return _ref69.apply(this, arguments);
			}

			return addClass;
		}()
	}, {
		key: 'removeClass',
		value: function () {
			var _ref70 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee47() {
				for (var _len5 = arguments.length, classes = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					classes[_key5] = arguments[_key5];
				}

				return _regenerator2.default.wrap(function _callee47$(_context47) {
					while (1) {
						switch (_context47.prev = _context47.next) {
							case 0:
								this.forEach(function (el) {
									var _el$classList2;

									return (_el$classList2 = el.classList).remove.apply(_el$classList2, (0, _toConsumableArray3.default)(classes));
								});
								return _context47.abrupt('return', this);

							case 2:
							case 'end':
								return _context47.stop();
						}
					}
				}, _callee47, this);
			}));

			function removeClass() {
				return _ref70.apply(this, arguments);
			}

			return removeClass;
		}()
	}, {
		key: 'hasClass',
		value: function () {
			var _ref71 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee48(cname) {
				return _regenerator2.default.wrap(function _callee48$(_context48) {
					while (1) {
						switch (_context48.prev = _context48.next) {
							case 0:
								return _context48.abrupt('return', this.some(function (el) {
									return el.classList.contains(cname);
								}));

							case 1:
							case 'end':
								return _context48.stop();
						}
					}
				}, _callee48, this);
			}));

			function hasClass(_x40) {
				return _ref71.apply(this, arguments);
			}

			return hasClass;
		}()
	}, {
		key: 'toggleClass',
		value: function () {
			var _ref72 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee49(cname) {
				var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				return _regenerator2.default.wrap(function _callee49$(_context49) {
					while (1) {
						switch (_context49.prev = _context49.next) {
							case 0:
								if (force instanceof Function) {
									this.forEach(function (node) {
										return node.classList.toggle(cname, force(node));
									});
								} else if (typeof force === 'boolean') {
									this.forEach(function (node) {
										return node.classList.toggle(cname, force);
									});
								} else {
									this.forEach(function (node) {
										return node.classList.toggle(cname);
									});
								}
								return _context49.abrupt('return', this);

							case 2:
							case 'end':
								return _context49.stop();
						}
					}
				}, _callee49, this);
			}));

			function toggleClass(_x42) {
				return _ref72.apply(this, arguments);
			}

			return toggleClass;
		}()
	}, {
		key: 'replaceClass',
		value: function () {
			var _ref73 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee50(cname1, cname2) {
				return _regenerator2.default.wrap(function _callee50$(_context50) {
					while (1) {
						switch (_context50.prev = _context50.next) {
							case 0:
								this.forEach(function (node) {
									return node.classList.replace(cname1, cname2);
								});
								return _context50.abrupt('return', this);

							case 2:
							case 'end':
								return _context50.stop();
						}
					}
				}, _callee50, this);
			}));

			function replaceClass(_x43, _x44) {
				return _ref73.apply(this, arguments);
			}

			return replaceClass;
		}()
	}, {
		key: 'pickClass',
		value: function () {
			var _ref74 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee51(cname1, cname2, condition) {
				return _regenerator2.default.wrap(function _callee51$(_context51) {
					while (1) {
						switch (_context51.prev = _context51.next) {
							case 0:
								this.toggleClass(cname1, condition);
								this.toggleClass(cname2, !condition);
								return _context51.abrupt('return', this);

							case 3:
							case 'end':
								return _context51.stop();
						}
					}
				}, _callee51, this);
			}));

			function pickClass(_x45, _x46, _x47) {
				return _ref74.apply(this, arguments);
			}

			return pickClass;
		}()
	}, {
		key: 'remove',
		value: function () {
			var _ref75 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee52() {
				return _regenerator2.default.wrap(function _callee52$(_context52) {
					while (1) {
						switch (_context52.prev = _context52.next) {
							case 0:
								this.forEach(function (el) {
									return el.remove();
								});
								return _context52.abrupt('return', this);

							case 2:
							case 'end':
								return _context52.stop();
						}
					}
				}, _callee52, this);
			}));

			function remove() {
				return _ref75.apply(this, arguments);
			}

			return remove;
		}()
	}, {
		key: 'empty',
		value: function () {
			var _ref76 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee53() {
				var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				return _regenerator2.default.wrap(function _callee53$(_context53) {
					while (1) {
						switch (_context53.prev = _context53.next) {
							case 0:
								if (typeof query === 'string') {
									this.forEach(function (node) {
										return [].concat((0, _toConsumableArray3.default)(node.children)).forEach(function (child) {
											if (child.matches(query)) {
												child.remove();
											}
										});
									});
								} else {
									this.forEach(function (node) {
										return [].concat((0, _toConsumableArray3.default)(node.children)).forEach(function (child) {
											return child.remove();
										});
									});
								}
								return _context53.abrupt('return', this);

							case 2:
							case 'end':
								return _context53.stop();
						}
					}
				}, _callee53, this);
			}));

			function empty() {
				return _ref76.apply(this, arguments);
			}

			return empty;
		}()
	}, {
		key: 'disable',
		value: function () {
			var _ref77 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee54() {
				var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				return _regenerator2.default.wrap(function _callee54$(_context54) {
					while (1) {
						switch (_context54.prev = _context54.next) {
							case 0:
								this.forEach(function (el) {
									return el.disabled = disabled;
								});

							case 1:
							case 'end':
								return _context54.stop();
						}
					}
				}, _callee54, this);
			}));

			function disable() {
				return _ref77.apply(this, arguments);
			}

			return disable;
		}()
	}, {
		key: 'enable',
		value: function () {
			var _ref78 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee55() {
				var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				return _regenerator2.default.wrap(function _callee55$(_context55) {
					while (1) {
						switch (_context55.prev = _context55.next) {
							case 0:
								this.disable(!enabled);

							case 1:
							case 'end':
								return _context55.stop();
						}
					}
				}, _callee55, this);
			}));

			function enable() {
				return _ref78.apply(this, arguments);
			}

			return enable;
		}()
	}, {
		key: 'hide',
		value: function () {
			var _ref79 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee56() {
				var hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				return _regenerator2.default.wrap(function _callee56$(_context56) {
					while (1) {
						switch (_context56.prev = _context56.next) {
							case 0:
								this.forEach(function (el) {
									return el.hidden = hidden;
								});
								return _context56.abrupt('return', this);

							case 2:
							case 'end':
								return _context56.stop();
						}
					}
				}, _callee56, this);
			}));

			function hide() {
				return _ref79.apply(this, arguments);
			}

			return hide;
		}()
	}, {
		key: 'unhide',
		value: function () {
			var _ref80 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee57() {
				var shown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				return _regenerator2.default.wrap(function _callee57$(_context57) {
					while (1) {
						switch (_context57.prev = _context57.next) {
							case 0:
								return _context57.abrupt('return', this.hide(!shown));

							case 1:
							case 'end':
								return _context57.stop();
						}
					}
				}, _callee57, this);
			}));

			function unhide() {
				return _ref80.apply(this, arguments);
			}

			return unhide;
		}()
	}, {
		key: 'append',
		value: function () {
			var _ref81 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee58() {
				for (var _len6 = arguments.length, nodes = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					nodes[_key6] = arguments[_key6];
				}

				return _regenerator2.default.wrap(function _callee58$(_context58) {
					while (1) {
						switch (_context58.prev = _context58.next) {
							case 0:
								this.forEach(function (el) {
									return el.append.apply(el, (0, _toConsumableArray3.default)(nodes));
								});
								return _context58.abrupt('return', this);

							case 2:
							case 'end':
								return _context58.stop();
						}
					}
				}, _callee58, this);
			}));

			function append() {
				return _ref81.apply(this, arguments);
			}

			return append;
		}()
	}, {
		key: 'prepend',
		value: function () {
			var _ref82 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee59() {
				for (var _len7 = arguments.length, nodes = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
					nodes[_key7] = arguments[_key7];
				}

				return _regenerator2.default.wrap(function _callee59$(_context59) {
					while (1) {
						switch (_context59.prev = _context59.next) {
							case 0:
								this.forEach(function (el) {
									return el.prepend.apply(el, (0, _toConsumableArray3.default)(nodes));
								});
								return _context59.abrupt('return', this);

							case 2:
							case 'end':
								return _context59.stop();
						}
					}
				}, _callee59, this);
			}));

			function prepend() {
				return _ref82.apply(this, arguments);
			}

			return prepend;
		}()
	}, {
		key: 'before',
		value: function () {
			var _ref83 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee60() {
				for (var _len8 = arguments.length, nodes = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
					nodes[_key8] = arguments[_key8];
				}

				return _regenerator2.default.wrap(function _callee60$(_context60) {
					while (1) {
						switch (_context60.prev = _context60.next) {
							case 0:
								this.forEach(function (el) {
									return el.before.apply(el, (0, _toConsumableArray3.default)(nodes));
								});
								return _context60.abrupt('return', this);

							case 2:
							case 'end':
								return _context60.stop();
						}
					}
				}, _callee60, this);
			}));

			function before() {
				return _ref83.apply(this, arguments);
			}

			return before;
		}()
	}, {
		key: 'after',
		value: function () {
			var _ref84 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee61() {
				for (var _len9 = arguments.length, nodes = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
					nodes[_key9] = arguments[_key9];
				}

				return _regenerator2.default.wrap(function _callee61$(_context61) {
					while (1) {
						switch (_context61.prev = _context61.next) {
							case 0:
								this.forEach(function (el) {
									return el.after.apply(el, (0, _toConsumableArray3.default)(nodes));
								});
								return _context61.abrupt('return', this);

							case 2:
							case 'end':
								return _context61.stop();
						}
					}
				}, _callee61, this);
			}));

			function after() {
				return _ref84.apply(this, arguments);
			}

			return after;
		}()
	}, {
		key: 'afterBegin',
		value: function () {
			var _ref85 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee62(text) {
				return _regenerator2.default.wrap(function _callee62$(_context62) {
					while (1) {
						switch (_context62.prev = _context62.next) {
							case 0:
								this.forEach(function (el) {
									return el.insertAdjacentHTML('afterbegin', text);
								});
								return _context62.abrupt('return', this);

							case 2:
							case 'end':
								return _context62.stop();
						}
					}
				}, _callee62, this);
			}));

			function afterBegin(_x53) {
				return _ref85.apply(this, arguments);
			}

			return afterBegin;
		}()
	}, {
		key: 'afterEnd',
		value: function () {
			var _ref86 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee63(text) {
				return _regenerator2.default.wrap(function _callee63$(_context63) {
					while (1) {
						switch (_context63.prev = _context63.next) {
							case 0:
								this.forEach(function (el) {
									return el.insertAdjacentHTML('afterend', text);
								});
								return _context63.abrupt('return', this);

							case 2:
							case 'end':
								return _context63.stop();
						}
					}
				}, _callee63, this);
			}));

			function afterEnd(_x54) {
				return _ref86.apply(this, arguments);
			}

			return afterEnd;
		}()
	}, {
		key: 'beforeBegin',
		value: function () {
			var _ref87 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee64(text) {
				return _regenerator2.default.wrap(function _callee64$(_context64) {
					while (1) {
						switch (_context64.prev = _context64.next) {
							case 0:
								this.forEach(function (el) {
									return el.insertAdjacentHTML('beforebegin', text);
								});
								return _context64.abrupt('return', this);

							case 2:
							case 'end':
								return _context64.stop();
						}
					}
				}, _callee64, this);
			}));

			function beforeBegin(_x55) {
				return _ref87.apply(this, arguments);
			}

			return beforeBegin;
		}()
	}, {
		key: 'beforeEnd',
		value: function () {
			var _ref88 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee65(text) {
				return _regenerator2.default.wrap(function _callee65$(_context65) {
					while (1) {
						switch (_context65.prev = _context65.next) {
							case 0:
								this.forEach(function (el) {
									return el.insertAdjacentHTML('beforeend', text);
								});
								return _context65.abrupt('return', this);

							case 2:
							case 'end':
								return _context65.stop();
						}
					}
				}, _callee65, this);
			}));

			function beforeEnd(_x56) {
				return _ref88.apply(this, arguments);
			}

			return beforeEnd;
		}()
	}, {
		key: 'hasAttribute',
		value: function () {
			var _ref89 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee66(attr) {
				return _regenerator2.default.wrap(function _callee66$(_context66) {
					while (1) {
						switch (_context66.prev = _context66.next) {
							case 0:
								return _context66.abrupt('return', this.some(function (el) {
									return el.hasAttribute(attr);
								}));

							case 1:
							case 'end':
								return _context66.stop();
						}
					}
				}, _callee66, this);
			}));

			function hasAttribute(_x57) {
				return _ref89.apply(this, arguments);
			}

			return hasAttribute;
		}()
	}, {
		key: 'attr',
		value: function () {
			var _ref90 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee67() {
				var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				return _regenerator2.default.wrap(function _callee67$(_context67) {
					while (1) {
						switch (_context67.prev = _context67.next) {
							case 0:
								this.forEach(function (node) {
									var _iteratorNormalCompletion = true;
									var _didIteratorError = false;
									var _iteratorError = undefined;

									try {
										for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(attrs)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
											var _ref91 = _step.value;

											var _ref92 = (0, _slicedToArray3.default)(_ref91, 2);

											var key = _ref92[0];
											var value = _ref92[1];

											switch (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) {
												case 'string':
												case 'number':
													node.setAttribute(key, value);
													break;
												case 'boolean':
													value ? node.setAttribute(key, '') : node.removeAttribute(key);
													break;
												default:
													node.removeAttribute(key);
											}
										}
									} catch (err) {
										_didIteratorError = true;
										_iteratorError = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion && _iterator.return) {
												_iterator.return();
											}
										} finally {
											if (_didIteratorError) {
												throw _iteratorError;
											}
										}
									}
								});
								return _context67.abrupt('return', this);

							case 2:
							case 'end':
								return _context67.stop();
						}
					}
				}, _callee67, this);
			}));

			function attr() {
				return _ref90.apply(this, arguments);
			}

			return attr;
		}()
	}, {
		key: 'data',
		value: function () {
			var _ref93 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee68() {
				var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				return _regenerator2.default.wrap(function _callee68$(_context68) {
					while (1) {
						switch (_context68.prev = _context68.next) {
							case 0:
								this.forEach(function (node) {
									var _iteratorNormalCompletion2 = true;
									var _didIteratorError2 = false;
									var _iteratorError2 = undefined;

									try {
										for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(props)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
											var _ref94 = _step2.value;

											var _ref95 = (0, _slicedToArray3.default)(_ref94, 2);

											var key = _ref95[0];
											var value = _ref95[1];

											if (value === false) {
												delete node.dataset[key];
											} else if (value === true || value === null) {
												node.dataset[key] = '';
											} else {
												node.dataset[key] = typeof value === 'string' ? value : (0, _stringify2.default)(value);
											}
										}
									} catch (err) {
										_didIteratorError2 = true;
										_iteratorError2 = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion2 && _iterator2.return) {
												_iterator2.return();
											}
										} finally {
											if (_didIteratorError2) {
												throw _iteratorError2;
											}
										}
									}
								});
								return _context68.abrupt('return', this);

							case 2:
							case 'end':
								return _context68.stop();
						}
					}
				}, _callee68, this);
			}));

			function data() {
				return _ref93.apply(this, arguments);
			}

			return data;
		}()
	}, {
		key: 'pause',
		value: function () {
			var _ref96 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee69() {
				return _regenerator2.default.wrap(function _callee69$(_context69) {
					while (1) {
						switch (_context69.prev = _context69.next) {
							case 0:
								this.forEach(function (media) {
									return media.pause();
								});
								return _context69.abrupt('return', this);

							case 2:
							case 'end':
								return _context69.stop();
						}
					}
				}, _callee69, this);
			}));

			function pause() {
				return _ref96.apply(this, arguments);
			}

			return pause;
		}()
	}, {
		key: 'read',
		value: function () {
			var _ref97 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee70() {
				return _regenerator2.default.wrap(function _callee70$(_context70) {
					while (1) {
						switch (_context70.prev = _context70.next) {
							case 0:
								_functions.read.apply(undefined, (0, _toConsumableArray3.default)(this));

							case 1:
							case 'end':
								return _context70.stop();
						}
					}
				}, _callee70, this);
			}));

			function read() {
				return _ref97.apply(this, arguments);
			}

			return read;
		}()

		/*==================== Listener Functions =================================*/

	}, {
		key: 'on',
		value: function () {
			var _ref98 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee71(event, callback) {
				for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
					args[_key10 - 2] = arguments[_key10];
				}

				return _regenerator2.default.wrap(function _callee71$(_context71) {
					while (1) {
						switch (_context71.prev = _context71.next) {
							case 0:
								this.forEach(function (node) {
									return node.addEventListener.apply(node, [event, callback].concat((0, _toConsumableArray3.default)(args)));
								});
								return _context71.abrupt('return', this);

							case 2:
							case 'end':
								return _context71.stop();
						}
					}
				}, _callee71, this);
			}));

			function on(_x60, _x61) {
				return _ref98.apply(this, arguments);
			}

			return on;
		}()
	}, {
		key: 'waitUntil',
		value: function () {
			var _ref99 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee72() {
				var _this2 = this;

				for (var _len11 = arguments.length, events = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
					events[_key11] = arguments[_key11];
				}

				return _regenerator2.default.wrap(function _callee72$(_context72) {
					while (1) {
						switch (_context72.prev = _context72.next) {
							case 0:
								return _context72.abrupt('return', _promise2.default.race(events.map(function (event) {
									return new _promise2.default(function (resolve) {
										return _this2.on(event, resolve, { once: true });
									});
								})));

							case 1:
							case 'end':
								return _context72.stop();
						}
					}
				}, _callee72, this);
			}));

			function waitUntil() {
				return _ref99.apply(this, arguments);
			}

			return waitUntil;
		}()
	}, {
		key: 'once',
		value: function () {
			var _ref100 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee73(event, callback) {
				return _regenerator2.default.wrap(function _callee73$(_context73) {
					while (1) {
						switch (_context73.prev = _context73.next) {
							case 0:
								return _context73.abrupt('return', this.on(event, callback, { once: true }));

							case 1:
							case 'end':
								return _context73.stop();
						}
					}
				}, _callee73, this);
			}));

			function once(_x62, _x63) {
				return _ref100.apply(this, arguments);
			}

			return once;
		}()
	}, {
		key: 'off',
		value: function () {
			var _ref101 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee74(event, callback) {
				return _regenerator2.default.wrap(function _callee74$(_context74) {
					while (1) {
						switch (_context74.prev = _context74.next) {
							case 0:
								this.forEach(function (node) {
									return node.removeEventListener(callback);
								});
								return _context74.abrupt('return', this);

							case 2:
							case 'end':
								return _context74.stop();
						}
					}
				}, _callee74, this);
			}));

			function off(_x64, _x65) {
				return _ref101.apply(this, arguments);
			}

			return off;
		}()
	}, {
		key: 'ready',
		value: function () {
			var _ref102 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee75(callback) {
				for (var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
					args[_key12 - 1] = arguments[_key12];
				}

				return _regenerator2.default.wrap(function _callee75$(_context75) {
					while (1) {
						switch (_context75.prev = _context75.next) {
							case 0:
								this.on.apply(this, ['DOMContentLoaded', callback].concat((0, _toConsumableArray3.default)(args)));
								if (document.readyState !== 'loading') {
									this.forEach(function (node) {
										callback.bind(node)(new Event('DOMContentLoaded'));
									}, false);
								}
								return _context75.abrupt('return', this);

							case 3:
							case 'end':
								return _context75.stop();
						}
					}
				}, _callee75, this);
			}));

			function ready(_x66) {
				return _ref102.apply(this, arguments);
			}

			return ready;
		}()
	}, {
		key: 'networkChange',
		value: function () {
			var _ref103 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee76(callback) {
				var _online;

				for (var _len13 = arguments.length, args = Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
					args[_key13 - 1] = arguments[_key13];
				}

				return _regenerator2.default.wrap(function _callee76$(_context76) {
					while (1) {
						switch (_context76.prev = _context76.next) {
							case 0:
								return _context76.abrupt('return', (_online = this.online.apply(this, [callback].concat((0, _toConsumableArray3.default)(args)))).offline.apply(_online, [callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context76.stop();
						}
					}
				}, _callee76, this);
			}));

			function networkChange(_x67) {
				return _ref103.apply(this, arguments);
			}

			return networkChange;
		}()
	}, {
		key: 'playing',
		value: function () {
			var _ref104 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee77(callback) {
				return _regenerator2.default.wrap(function _callee77$(_context77) {
					while (1) {
						switch (_context77.prev = _context77.next) {
							case 0:
								this.forEach(function (e) {
									return e.onplay = callback;
								});
								return _context77.abrupt('return', this);

							case 2:
							case 'end':
								return _context77.stop();
						}
					}
				}, _callee77, this);
			}));

			function playing(_x68) {
				return _ref104.apply(this, arguments);
			}

			return playing;
		}()
	}, {
		key: 'paused',
		value: function () {
			var _ref105 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee78(callback) {
				return _regenerator2.default.wrap(function _callee78$(_context78) {
					while (1) {
						switch (_context78.prev = _context78.next) {
							case 0:
								this.forEach(function (e) {
									return e.onpause = callback;
								}, false);
								return _context78.abrupt('return', this);

							case 2:
							case 'end':
								return _context78.stop();
						}
					}
				}, _callee78, this);
			}));

			function paused(_x69) {
				return _ref105.apply(this, arguments);
			}

			return paused;
		}()
	}, {
		key: 'visibilitychange',
		value: function () {
			var _ref106 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee79(callback) {
				for (var _len14 = arguments.length, args = Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
					args[_key14 - 1] = arguments[_key14];
				}

				return _regenerator2.default.wrap(function _callee79$(_context79) {
					while (1) {
						switch (_context79.prev = _context79.next) {
							case 0:
								this.forEach(function (e) {
									PREFIXES.forEach(function (pre) {
										e.addEventListener.apply(e, [pre + 'visibilitychange', callback].concat((0, _toConsumableArray3.default)(args)));
									});
								}, false);
								return _context79.abrupt('return', this);

							case 2:
							case 'end':
								return _context79.stop();
						}
					}
				}, _callee79, this);
			}));

			function visibilitychange(_x70) {
				return _ref106.apply(this, arguments);
			}

			return visibilitychange;
		}()
	}, {
		key: 'click',
		value: function () {
			var _ref107 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee80(callback) {
				for (var _len15 = arguments.length, args = Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
					args[_key15 - 1] = arguments[_key15];
				}

				return _regenerator2.default.wrap(function _callee80$(_context80) {
					while (1) {
						switch (_context80.prev = _context80.next) {
							case 0:
								return _context80.abrupt('return', this.on.apply(this, ['click', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context80.stop();
						}
					}
				}, _callee80, this);
			}));

			function click(_x71) {
				return _ref107.apply(this, arguments);
			}

			return click;
		}()
	}, {
		key: 'dblclick',
		value: function () {
			var _ref108 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee81(callback) {
				for (var _len16 = arguments.length, args = Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
					args[_key16 - 1] = arguments[_key16];
				}

				return _regenerator2.default.wrap(function _callee81$(_context81) {
					while (1) {
						switch (_context81.prev = _context81.next) {
							case 0:
								this.on.apply(this, ['dblclick', callback].concat((0, _toConsumableArray3.default)(args)));

							case 1:
							case 'end':
								return _context81.stop();
						}
					}
				}, _callee81, this);
			}));

			function dblclick(_x72) {
				return _ref108.apply(this, arguments);
			}

			return dblclick;
		}()
	}, {
		key: 'contextmenu',
		value: function () {
			var _ref109 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee82(callback) {
				for (var _len17 = arguments.length, args = Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
					args[_key17 - 1] = arguments[_key17];
				}

				return _regenerator2.default.wrap(function _callee82$(_context82) {
					while (1) {
						switch (_context82.prev = _context82.next) {
							case 0:
								return _context82.abrupt('return', this.on.apply(this, ['contextmenu', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context82.stop();
						}
					}
				}, _callee82, this);
			}));

			function contextmenu(_x73) {
				return _ref109.apply(this, arguments);
			}

			return contextmenu;
		}()
	}, {
		key: 'keypress',
		value: function () {
			var _ref110 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee83(callback) {
				for (var _len18 = arguments.length, args = Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
					args[_key18 - 1] = arguments[_key18];
				}

				return _regenerator2.default.wrap(function _callee83$(_context83) {
					while (1) {
						switch (_context83.prev = _context83.next) {
							case 0:
								return _context83.abrupt('return', this.on.apply(this, ['keypress', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context83.stop();
						}
					}
				}, _callee83, this);
			}));

			function keypress(_x74) {
				return _ref110.apply(this, arguments);
			}

			return keypress;
		}()
	}, {
		key: 'keyup',
		value: function () {
			var _ref111 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee84(callback) {
				for (var _len19 = arguments.length, args = Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
					args[_key19 - 1] = arguments[_key19];
				}

				return _regenerator2.default.wrap(function _callee84$(_context84) {
					while (1) {
						switch (_context84.prev = _context84.next) {
							case 0:
								return _context84.abrupt('return', this.on.apply(this, ['keyup', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context84.stop();
						}
					}
				}, _callee84, this);
			}));

			function keyup(_x75) {
				return _ref111.apply(this, arguments);
			}

			return keyup;
		}()
	}, {
		key: 'keydown',
		value: function () {
			var _ref112 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee85(callback) {
				for (var _len20 = arguments.length, args = Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
					args[_key20 - 1] = arguments[_key20];
				}

				return _regenerator2.default.wrap(function _callee85$(_context85) {
					while (1) {
						switch (_context85.prev = _context85.next) {
							case 0:
								return _context85.abrupt('return', this.on.apply(this, ['keydown'].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context85.stop();
						}
					}
				}, _callee85, this);
			}));

			function keydown(_x76) {
				return _ref112.apply(this, arguments);
			}

			return keydown;
		}()
	}, {
		key: 'mouseenter',
		value: function () {
			var _ref113 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee86(callback) {
				for (var _len21 = arguments.length, args = Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
					args[_key21 - 1] = arguments[_key21];
				}

				return _regenerator2.default.wrap(function _callee86$(_context86) {
					while (1) {
						switch (_context86.prev = _context86.next) {
							case 0:
								return _context86.abrupt('return', this.on.apply(this, ['mouseenter', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context86.stop();
						}
					}
				}, _callee86, this);
			}));

			function mouseenter(_x77) {
				return _ref113.apply(this, arguments);
			}

			return mouseenter;
		}()
	}, {
		key: 'mouseleave',
		value: function () {
			var _ref114 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee87(callback) {
				for (var _len22 = arguments.length, args = Array(_len22 > 1 ? _len22 - 1 : 0), _key22 = 1; _key22 < _len22; _key22++) {
					args[_key22 - 1] = arguments[_key22];
				}

				return _regenerator2.default.wrap(function _callee87$(_context87) {
					while (1) {
						switch (_context87.prev = _context87.next) {
							case 0:
								return _context87.abrupt('return', this.on.apply(this, ['mouseleave', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context87.stop();
						}
					}
				}, _callee87, this);
			}));

			function mouseleave(_x78) {
				return _ref114.apply(this, arguments);
			}

			return mouseleave;
		}()
	}, {
		key: 'mouseover',
		value: function () {
			var _ref115 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee88(callback) {
				for (var _len23 = arguments.length, args = Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
					args[_key23 - 1] = arguments[_key23];
				}

				return _regenerator2.default.wrap(function _callee88$(_context88) {
					while (1) {
						switch (_context88.prev = _context88.next) {
							case 0:
								return _context88.abrupt('return', this.on.apply(this, ['mouseover', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context88.stop();
						}
					}
				}, _callee88, this);
			}));

			function mouseover(_x79) {
				return _ref115.apply(this, arguments);
			}

			return mouseover;
		}()
	}, {
		key: 'mouseout',
		value: function () {
			var _ref116 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee89(callback) {
				for (var _len24 = arguments.length, args = Array(_len24 > 1 ? _len24 - 1 : 0), _key24 = 1; _key24 < _len24; _key24++) {
					args[_key24 - 1] = arguments[_key24];
				}

				return _regenerator2.default.wrap(function _callee89$(_context89) {
					while (1) {
						switch (_context89.prev = _context89.next) {
							case 0:
								return _context89.abrupt('return', this.on.apply(this, ['mouseout', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context89.stop();
						}
					}
				}, _callee89, this);
			}));

			function mouseout(_x80) {
				return _ref116.apply(this, arguments);
			}

			return mouseout;
		}()
	}, {
		key: 'mousemove',
		value: function () {
			var _ref117 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee90(callback) {
				for (var _len25 = arguments.length, args = Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
					args[_key25 - 1] = arguments[_key25];
				}

				return _regenerator2.default.wrap(function _callee90$(_context90) {
					while (1) {
						switch (_context90.prev = _context90.next) {
							case 0:
								return _context90.abrupt('return', this.on.apply(this, ['mousemove', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context90.stop();
						}
					}
				}, _callee90, this);
			}));

			function mousemove(_x81) {
				return _ref117.apply(this, arguments);
			}

			return mousemove;
		}()
	}, {
		key: 'mousedown',
		value: function () {
			var _ref118 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee91(callback) {
				for (var _len26 = arguments.length, args = Array(_len26 > 1 ? _len26 - 1 : 0), _key26 = 1; _key26 < _len26; _key26++) {
					args[_key26 - 1] = arguments[_key26];
				}

				return _regenerator2.default.wrap(function _callee91$(_context91) {
					while (1) {
						switch (_context91.prev = _context91.next) {
							case 0:
								return _context91.abrupt('return', this.on.apply(this, ['mousedown', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context91.stop();
						}
					}
				}, _callee91, this);
			}));

			function mousedown(_x82) {
				return _ref118.apply(this, arguments);
			}

			return mousedown;
		}()
	}, {
		key: 'mouseup',
		value: function () {
			var _ref119 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee92(callback) {
				for (var _len27 = arguments.length, args = Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
					args[_key27 - 1] = arguments[_key27];
				}

				return _regenerator2.default.wrap(function _callee92$(_context92) {
					while (1) {
						switch (_context92.prev = _context92.next) {
							case 0:
								return _context92.abrupt('return', this.on.apply(this, ['mouseup', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context92.stop();
						}
					}
				}, _callee92, this);
			}));

			function mouseup(_x83) {
				return _ref119.apply(this, arguments);
			}

			return mouseup;
		}()
	}, {
		key: 'input',
		value: function () {
			var _ref120 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee93(callback) {
				for (var _len28 = arguments.length, args = Array(_len28 > 1 ? _len28 - 1 : 0), _key28 = 1; _key28 < _len28; _key28++) {
					args[_key28 - 1] = arguments[_key28];
				}

				return _regenerator2.default.wrap(function _callee93$(_context93) {
					while (1) {
						switch (_context93.prev = _context93.next) {
							case 0:
								return _context93.abrupt('return', this.on.apply(this, ['input', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context93.stop();
						}
					}
				}, _callee93, this);
			}));

			function input(_x84) {
				return _ref120.apply(this, arguments);
			}

			return input;
		}()
	}, {
		key: 'change',
		value: function () {
			var _ref121 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee94(callback) {
				for (var _len29 = arguments.length, args = Array(_len29 > 1 ? _len29 - 1 : 0), _key29 = 1; _key29 < _len29; _key29++) {
					args[_key29 - 1] = arguments[_key29];
				}

				return _regenerator2.default.wrap(function _callee94$(_context94) {
					while (1) {
						switch (_context94.prev = _context94.next) {
							case 0:
								return _context94.abrupt('return', this.on.apply(this, ['change', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context94.stop();
						}
					}
				}, _callee94, this);
			}));

			function change(_x85) {
				return _ref121.apply(this, arguments);
			}

			return change;
		}()
	}, {
		key: 'submit',
		value: function () {
			var _ref122 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee95(callback) {
				for (var _len30 = arguments.length, args = Array(_len30 > 1 ? _len30 - 1 : 0), _key30 = 1; _key30 < _len30; _key30++) {
					args[_key30 - 1] = arguments[_key30];
				}

				return _regenerator2.default.wrap(function _callee95$(_context95) {
					while (1) {
						switch (_context95.prev = _context95.next) {
							case 0:
								return _context95.abrupt('return', this.on.apply(this, ['submit', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context95.stop();
						}
					}
				}, _callee95, this);
			}));

			function submit(_x86) {
				return _ref122.apply(this, arguments);
			}

			return submit;
		}()
	}, {
		key: 'reset',
		value: function () {
			var _ref123 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee96(callback) {
				for (var _len31 = arguments.length, args = Array(_len31 > 1 ? _len31 - 1 : 0), _key31 = 1; _key31 < _len31; _key31++) {
					args[_key31 - 1] = arguments[_key31];
				}

				return _regenerator2.default.wrap(function _callee96$(_context96) {
					while (1) {
						switch (_context96.prev = _context96.next) {
							case 0:
								return _context96.abrupt('return', this.on.apply(this, ['reset', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context96.stop();
						}
					}
				}, _callee96, this);
			}));

			function reset(_x87) {
				return _ref123.apply(this, arguments);
			}

			return reset;
		}()
	}, {
		key: 'invalid',
		value: function () {
			var _ref124 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee97(callback) {
				for (var _len32 = arguments.length, args = Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
					args[_key32 - 1] = arguments[_key32];
				}

				return _regenerator2.default.wrap(function _callee97$(_context97) {
					while (1) {
						switch (_context97.prev = _context97.next) {
							case 0:
								return _context97.abrupt('return', this.on.apply(this, ['invalid', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context97.stop();
						}
					}
				}, _callee97, this);
			}));

			function invalid(_x88) {
				return _ref124.apply(this, arguments);
			}

			return invalid;
		}()
	}, {
		key: 'select',
		value: function () {
			var _ref125 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee98(callback) {
				for (var _len33 = arguments.length, args = Array(_len33 > 1 ? _len33 - 1 : 0), _key33 = 1; _key33 < _len33; _key33++) {
					args[_key33 - 1] = arguments[_key33];
				}

				return _regenerator2.default.wrap(function _callee98$(_context98) {
					while (1) {
						switch (_context98.prev = _context98.next) {
							case 0:
								return _context98.abrupt('return', this.on.apply(this, ['select', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context98.stop();
						}
					}
				}, _callee98, this);
			}));

			function select(_x89) {
				return _ref125.apply(this, arguments);
			}

			return select;
		}()
	}, {
		key: 'focus',
		value: function () {
			var _ref126 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee99(callback) {
				for (var _len34 = arguments.length, args = Array(_len34 > 1 ? _len34 - 1 : 0), _key34 = 1; _key34 < _len34; _key34++) {
					args[_key34 - 1] = arguments[_key34];
				}

				return _regenerator2.default.wrap(function _callee99$(_context99) {
					while (1) {
						switch (_context99.prev = _context99.next) {
							case 0:
								return _context99.abrupt('return', this.on.apply(this, ['focus', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context99.stop();
						}
					}
				}, _callee99, this);
			}));

			function focus(_x90) {
				return _ref126.apply(this, arguments);
			}

			return focus;
		}()
	}, {
		key: 'blur',
		value: function () {
			var _ref127 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee100(callback) {
				for (var _len35 = arguments.length, args = Array(_len35 > 1 ? _len35 - 1 : 0), _key35 = 1; _key35 < _len35; _key35++) {
					args[_key35 - 1] = arguments[_key35];
				}

				return _regenerator2.default.wrap(function _callee100$(_context100) {
					while (1) {
						switch (_context100.prev = _context100.next) {
							case 0:
								return _context100.abrupt('return', this.on.apply(this, ['blur', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context100.stop();
						}
					}
				}, _callee100, this);
			}));

			function blur(_x91) {
				return _ref127.apply(this, arguments);
			}

			return blur;
		}()
	}, {
		key: 'resize',
		value: function () {
			var _ref128 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee101(callback) {
				for (var _len36 = arguments.length, args = Array(_len36 > 1 ? _len36 - 1 : 0), _key36 = 1; _key36 < _len36; _key36++) {
					args[_key36 - 1] = arguments[_key36];
				}

				return _regenerator2.default.wrap(function _callee101$(_context101) {
					while (1) {
						switch (_context101.prev = _context101.next) {
							case 0:
								return _context101.abrupt('return', this.on.apply(this, ['resize', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context101.stop();
						}
					}
				}, _callee101, this);
			}));

			function resize(_x92) {
				return _ref128.apply(this, arguments);
			}

			return resize;
		}()
	}, {
		key: 'updateready',
		value: function () {
			var _ref129 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee102(callback) {
				for (var _len37 = arguments.length, args = Array(_len37 > 1 ? _len37 - 1 : 0), _key37 = 1; _key37 < _len37; _key37++) {
					args[_key37 - 1] = arguments[_key37];
				}

				return _regenerator2.default.wrap(function _callee102$(_context102) {
					while (1) {
						switch (_context102.prev = _context102.next) {
							case 0:
								return _context102.abrupt('return', this.on.apply(this, ['updateready'].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context102.stop();
						}
					}
				}, _callee102, this);
			}));

			function updateready(_x93) {
				return _ref129.apply(this, arguments);
			}

			return updateready;
		}()
	}, {
		key: 'load',
		value: function () {
			var _ref130 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee103(callback) {
				for (var _len38 = arguments.length, args = Array(_len38 > 1 ? _len38 - 1 : 0), _key38 = 1; _key38 < _len38; _key38++) {
					args[_key38 - 1] = arguments[_key38];
				}

				return _regenerator2.default.wrap(function _callee103$(_context103) {
					while (1) {
						switch (_context103.prev = _context103.next) {
							case 0:
								this.on.apply(this, ['load', callback].concat((0, _toConsumableArray3.default)(args)));
								if (document.readyState === 'complete') {
									document.dispatchEvent(new Event('load'));
								}
								return _context103.abrupt('return', this);

							case 3:
							case 'end':
								return _context103.stop();
						}
					}
				}, _callee103, this);
			}));

			function load(_x94) {
				return _ref130.apply(this, arguments);
			}

			return load;
		}()
	}, {
		key: 'unload',
		value: function () {
			var _ref131 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee104(callback) {
				for (var _len39 = arguments.length, args = Array(_len39 > 1 ? _len39 - 1 : 0), _key39 = 1; _key39 < _len39; _key39++) {
					args[_key39 - 1] = arguments[_key39];
				}

				return _regenerator2.default.wrap(function _callee104$(_context104) {
					while (1) {
						switch (_context104.prev = _context104.next) {
							case 0:
								return _context104.abrupt('return', this.on.apply(this, ['unload', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context104.stop();
						}
					}
				}, _callee104, this);
			}));

			function unload(_x95) {
				return _ref131.apply(this, arguments);
			}

			return unload;
		}()
	}, {
		key: 'beforeunload',
		value: function () {
			var _ref132 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee105(callback) {
				for (var _len40 = arguments.length, args = Array(_len40 > 1 ? _len40 - 1 : 0), _key40 = 1; _key40 < _len40; _key40++) {
					args[_key40 - 1] = arguments[_key40];
				}

				return _regenerator2.default.wrap(function _callee105$(_context105) {
					while (1) {
						switch (_context105.prev = _context105.next) {
							case 0:
								return _context105.abrupt('return', this.on.apply(this, ['beforeunload', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context105.stop();
						}
					}
				}, _callee105, this);
			}));

			function beforeunload(_x96) {
				return _ref132.apply(this, arguments);
			}

			return beforeunload;
		}()
	}, {
		key: 'abort',
		value: function () {
			var _ref133 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee106(callback) {
				for (var _len41 = arguments.length, args = Array(_len41 > 1 ? _len41 - 1 : 0), _key41 = 1; _key41 < _len41; _key41++) {
					args[_key41 - 1] = arguments[_key41];
				}

				return _regenerator2.default.wrap(function _callee106$(_context106) {
					while (1) {
						switch (_context106.prev = _context106.next) {
							case 0:
								return _context106.abrupt('return', this.on.apply(this, ['abort', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context106.stop();
						}
					}
				}, _callee106, this);
			}));

			function abort(_x97) {
				return _ref133.apply(this, arguments);
			}

			return abort;
		}()
	}, {
		key: 'error',
		value: function () {
			var _ref134 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee107(callback) {
				for (var _len42 = arguments.length, args = Array(_len42 > 1 ? _len42 - 1 : 0), _key42 = 1; _key42 < _len42; _key42++) {
					args[_key42 - 1] = arguments[_key42];
				}

				return _regenerator2.default.wrap(function _callee107$(_context107) {
					while (1) {
						switch (_context107.prev = _context107.next) {
							case 0:
								return _context107.abrupt('return', this.on.apply(this, ['error', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context107.stop();
						}
					}
				}, _callee107, this);
			}));

			function error(_x98) {
				return _ref134.apply(this, arguments);
			}

			return error;
		}()
	}, {
		key: 'scroll',
		value: function () {
			var _ref135 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee108(callback) {
				for (var _len43 = arguments.length, args = Array(_len43 > 1 ? _len43 - 1 : 0), _key43 = 1; _key43 < _len43; _key43++) {
					args[_key43 - 1] = arguments[_key43];
				}

				return _regenerator2.default.wrap(function _callee108$(_context108) {
					while (1) {
						switch (_context108.prev = _context108.next) {
							case 0:
								return _context108.abrupt('return', this.on.apply(this, ['scroll'].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context108.stop();
						}
					}
				}, _callee108, this);
			}));

			function scroll(_x99) {
				return _ref135.apply(this, arguments);
			}

			return scroll;
		}()
	}, {
		key: 'drag',
		value: function () {
			var _ref136 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee109(callback) {
				for (var _len44 = arguments.length, args = Array(_len44 > 1 ? _len44 - 1 : 0), _key44 = 1; _key44 < _len44; _key44++) {
					args[_key44 - 1] = arguments[_key44];
				}

				return _regenerator2.default.wrap(function _callee109$(_context109) {
					while (1) {
						switch (_context109.prev = _context109.next) {
							case 0:
								return _context109.abrupt('return', this.on.apply(this, ['drag', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context109.stop();
						}
					}
				}, _callee109, this);
			}));

			function drag(_x100) {
				return _ref136.apply(this, arguments);
			}

			return drag;
		}()
	}, {
		key: 'offline',
		value: function () {
			var _ref137 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee110(callback) {
				for (var _len45 = arguments.length, args = Array(_len45 > 1 ? _len45 - 1 : 0), _key45 = 1; _key45 < _len45; _key45++) {
					args[_key45 - 1] = arguments[_key45];
				}

				return _regenerator2.default.wrap(function _callee110$(_context110) {
					while (1) {
						switch (_context110.prev = _context110.next) {
							case 0:
								return _context110.abrupt('return', this.on.apply(this, ['offline', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context110.stop();
						}
					}
				}, _callee110, this);
			}));

			function offline(_x101) {
				return _ref137.apply(this, arguments);
			}

			return offline;
		}()
	}, {
		key: 'online',
		value: function () {
			var _ref138 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee111(callback) {
				for (var _len46 = arguments.length, args = Array(_len46 > 1 ? _len46 - 1 : 0), _key46 = 1; _key46 < _len46; _key46++) {
					args[_key46 - 1] = arguments[_key46];
				}

				return _regenerator2.default.wrap(function _callee111$(_context111) {
					while (1) {
						switch (_context111.prev = _context111.next) {
							case 0:
								return _context111.abrupt('return', this.on.apply(this, ['online', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context111.stop();
						}
					}
				}, _callee111, this);
			}));

			function online(_x102) {
				return _ref138.apply(this, arguments);
			}

			return online;
		}()
	}, {
		key: 'hashchange',
		value: function () {
			var _ref139 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee112(callback) {
				for (var _len47 = arguments.length, args = Array(_len47 > 1 ? _len47 - 1 : 0), _key47 = 1; _key47 < _len47; _key47++) {
					args[_key47 - 1] = arguments[_key47];
				}

				return _regenerator2.default.wrap(function _callee112$(_context112) {
					while (1) {
						switch (_context112.prev = _context112.next) {
							case 0:
								return _context112.abrupt('return', this.on.apply(this, ['hashchange', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context112.stop();
						}
					}
				}, _callee112, this);
			}));

			function hashchange(_x103) {
				return _ref139.apply(this, arguments);
			}

			return hashchange;
		}()

		/*visibilitychange(callback) {
  	return this.on('visibilitychange', callback);
  }*/

	}, {
		key: 'popstate',
		value: function () {
			var _ref140 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee113(callback) {
				for (var _len48 = arguments.length, args = Array(_len48 > 1 ? _len48 - 1 : 0), _key48 = 1; _key48 < _len48; _key48++) {
					args[_key48 - 1] = arguments[_key48];
				}

				return _regenerator2.default.wrap(function _callee113$(_context113) {
					while (1) {
						switch (_context113.prev = _context113.next) {
							case 0:
								return _context113.abrupt('return', this.on.apply(this, ['popstate', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context113.stop();
						}
					}
				}, _callee113, this);
			}));

			function popstate(_x104) {
				return _ref140.apply(this, arguments);
			}

			return popstate;
		}()
	}, {
		key: 'pagehide',
		value: function () {
			var _ref141 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee114(callback) {
				for (var _len49 = arguments.length, args = Array(_len49 > 1 ? _len49 - 1 : 0), _key49 = 1; _key49 < _len49; _key49++) {
					args[_key49 - 1] = arguments[_key49];
				}

				return _regenerator2.default.wrap(function _callee114$(_context114) {
					while (1) {
						switch (_context114.prev = _context114.next) {
							case 0:
								return _context114.abrupt('return', this.on.apply(this, ['pagehide', callback].concat((0, _toConsumableArray3.default)(args))));

							case 1:
							case 'end':
								return _context114.stop();
						}
					}
				}, _callee114, this);
			}));

			function pagehide(_x105) {
				return _ref141.apply(this, arguments);
			}

			return pagehide;
		}()
	}, {
		key: 'watch',
		value: function () {
			var _ref142 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee115(watching) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
				var attributeFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
				var watcher, obs;
				return _regenerator2.default.wrap(function _callee115$(_context115) {
					while (1) {
						switch (_context115.prev = _context115.next) {
							case 0:
								/*https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver*/
								watcher = new MutationObserver(function (mutations) {
									mutations.forEach(function (mutation) {
										return watching[mutation.type].call(mutation);
									});
								});
								obs = (0, _keys2.default)(watching).concat(options).reduce(function (watch, event) {
									watch[event] = true;
									return watch;
								}, { attributeFilter: attributeFilter });

								this.forEach(function (el) {
									return watcher.observe(el, obs);
								});
								return _context115.abrupt('return', this);

							case 4:
							case 'end':
								return _context115.stop();
						}
					}
				}, _callee115, this);
			}));

			function watch(_x108) {
				return _ref142.apply(this, arguments);
			}

			return watch;
		}()

		/**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
   */

	}, {
		key: 'intersect',
		value: function () {
			var _ref143 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee116(callback) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				var observer;
				return _regenerator2.default.wrap(function _callee116$(_context116) {
					while (1) {
						switch (_context116.prev = _context116.next) {
							case 0:
								try {
									observer = new IntersectionObserver(callback, options);

									this.forEach(function (node) {
										return observer.observe(node);
									});
								} catch (err) {
									console.error(err);
								}
								return _context116.abrupt('return', this);

							case 2:
							case 'end':
								return _context116.stop();
						}
					}
				}, _callee116, this);
			}));

			function intersect(_x110) {
				return _ref143.apply(this, arguments);
			}

			return intersect;
		}()
	}, {
		key: 'css',
		value: function () {
			var _ref144 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee117() {
				var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				return _regenerator2.default.wrap(function _callee117$(_context117) {
					while (1) {
						switch (_context117.prev = _context117.next) {
							case 0:
								this.forEach(function (node) {
									(0, _keys2.default)(props).forEach(function (prop) {
										node.style.setProperty(prop, props[prop]);
									});
								});
								return _context117.abrupt('return', this);

							case 2:
							case 'end':
								return _context117.stop();
						}
					}
				}, _callee117, this);
			}));

			function css() {
				return _ref144.apply(this, arguments);
			}

			return css;
		}()
	}, {
		key: 'found',
		get: function get() {
			return this.size !== 0;
		}
	}]);
	return esQuery;
}(_set2.default);

exports.default = esQuery;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(127), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35);
__webpack_require__(13);
__webpack_require__(22);
__webpack_require__(128);
__webpack_require__(134);
__webpack_require__(137);
__webpack_require__(139);
module.exports = __webpack_require__(0).Set;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(129);
var validate = __webpack_require__(78);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(130)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(4).f;
var create = __webpack_require__(28);
var redefineAll = __webpack_require__(48);
var ctx = __webpack_require__(8);
var anInstance = __webpack_require__(45);
var forOf = __webpack_require__(23);
var $iterDefine = __webpack_require__(38);
var step = __webpack_require__(59);
var setSpecies = __webpack_require__(66);
var DESCRIPTORS = __webpack_require__(7);
var fastKey = __webpack_require__(52).fastKey;
var validate = __webpack_require__(78);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(1);
var meta = __webpack_require__(52);
var fails = __webpack_require__(10);
var hide = __webpack_require__(9);
var redefineAll = __webpack_require__(48);
var forOf = __webpack_require__(23);
var anInstance = __webpack_require__(45);
var isObject = __webpack_require__(5);
var setToStringTag = __webpack_require__(21);
var dP = __webpack_require__(4).f;
var each = __webpack_require__(131)(0);
var DESCRIPTORS = __webpack_require__(7);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(8);
var IObject = __webpack_require__(41);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(29);
var asc = __webpack_require__(132);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(133);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var isArray = __webpack_require__(74);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(135)('Set') });


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(31);
var from = __webpack_require__(136);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(23);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(138)('Set');


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(140)('Set');


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(18);
var ctx = __webpack_require__(8);
var forOf = __webpack_require__(23);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(142), __esModule: true };

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(144), __esModule: true };

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(16);
var $keys = __webpack_require__(15);

__webpack_require__(79)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(147), __esModule: true };

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(148);
module.exports = __webpack_require__(0).Object.getPrototypeOf;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(16);
var $getPrototypeOf = __webpack_require__(58);

__webpack_require__(79)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(34);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(151);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(155);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(34);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(152), __esModule: true };

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
module.exports = __webpack_require__(0).Object.setPrototypeOf;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(154).set });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(5);
var anObject = __webpack_require__(6);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(8)(Function.call, __webpack_require__(76).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(156), __esModule: true };

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(157);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(28) });


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(32);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(33);

var _entries2 = _interopRequireDefault(_entries);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Remove JavaScript style & animations & create rules in core-css
/**
 * Configure Web Share API Shim with share params {url, icon, label}s
 * @param share {url, icon, label)[, {}, [...]]
 * @return Promise
 */
exports.default = function () {
	for (var _len = arguments.length, shares = Array(_len), _key = 0; _key < _len; _key++) {
		shares[_key] = arguments[_key];
	}

	shares.forEach(function (share) {
		return share.url = new URL(share.url);
	});
	if (!Navigator.prototype.hasOwnProperty('share')) {
		Navigator.prototype.share = function () {
			var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
			    _ref$text = _ref.text,
			    text = _ref$text === undefined ? null : _ref$text,
			    _ref$title = _ref.title,
			    title = _ref$title === undefined ? null : _ref$title,
			    _ref$url = _ref.url,
			    url = _ref$url === undefined ? null : _ref$url;

			return new _promise2.default(function (resolve, reject) {
				var size = 64;
				var dialog = document.createElement('dialog');
				var header = document.createElement('header');
				var close = document.createElement('button');
				var body = document.createElement('div');
				var msg = document.createElement('b');
				var font = 'Roboto, Helvetica, "Sans Seriff"';

				var styles = {
					dialog: {
						display: 'block',
						position: 'fixed',
						background: '#fefefe',
						top: '0',
						bottom: 'auto',
						left: '0',
						right: '0',
						transform: 'none',
						'border-radius': '0 0 5px 5px',
						'max-height': '500px'
					},
					header: {
						height: '47px',
						'line-height': '47px',
						color: '#232323',
						'box-shadow': 'none',
						'border-bottom': '1px solid #d5d5d5'
					},
					closeBtn: {
						float: 'right',
						'font-family': font,
						'font-weight': 'bold',
						'font-size': '16px',
						color: 'black',
						border: 'none',
						background: 'transparent'
					},
					msg: {
						'font-family': font,
						'font-size': '24px',
						display: 'block'
					},
					link: {
						display: 'inline-block',
						margin: '0.3em',
						'text-decoration': 'none',
						color: '#626262',
						'text-align': 'center',
						'font-family': font,
						'font-size': '20px'
					}
				};

				function closeDialog(event) {
					if (event.type === 'click' && !event.target.matches('dialog[open],dialog[open] *') || event.type === 'keypress' && event.code === 'Escape') {
						dialog.close('Share canceled');
					}
				}

				function css(el, rules) {
					(0, _entries2.default)(rules).forEach(function (_ref2) {
						var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
						    key = _ref3[0],
						    value = _ref3[1];

						el.style.setProperty(key, value);
					});
				}

				function closeHandler(event) {
					if (Element.prototype.hasOwnProperty('animate')) {
						var rects = dialog.getClientRects()[0];
						var anim = dialog.animate([{ top: 0 }, { top: '-' + rects.height + 'px' }], {
							duration: 400,
							easing: 'ease-out',
							fill: 'both'
						});
						anim.onfinish = function () {
							return dialog.remove();
						};
						anim.onerror = function () {
							return dialog.remove();
						};
						anim.oncancel = function () {
							return dialog.remove();
						};
					} else {
						dialog.remove();
					}

					document.removeEventListener('keypress', closeDialog);
					document.removeEventListener('click', closeDialog);
					reject(new DOMException(event.detail));
				}

				if (text === null && title === null && url === null) {
					reject(new TypeError('No known share data fields supplied. If using only new fields (other than title, text and url), you must feature-detect them first.'));
				} else if (shares.length === 0) {
					reject(new Error('No shares configured'));
				} else {
					msg.textContent = 'Share via';
					close.title = 'Close dialog';

					shares.forEach(function (share) {
						var link = document.createElement('a');
						var icon = new Image(size, size);

						if (share.url.searchParams.has('url')) {
							share.url.searchParams.set('url', url);
						} else if (share.url.searchParams.has('u')) {
							share.url.searchParams.set('u', url);
						}

						if (share.url.searchParams.has('title')) {
							share.url.searchParams.set('title', title);
						} else if (share.url.searchParams.has('t')) {
							share.url.searchParams.set('t', title);
						} else if (share.url.searchParams.has('subject')) {
							share.url.searchParams.set('subject', title);
						} else if (share.url.searchParams.has('su')) {
							share.url.searchParams.set('su', title);
						}

						if (share.url.searchParams.has('text')) {
							share.url.searchParams.set('text', text);
						} else if (share.url.searchParams.has('summary')) {
							share.url.searchParams.set('summary', text);
						} else if (share.url.searchParams.has('body')) {
							share.url.searchParams.set('body', text + '\n' + url);
						}

						css(link, styles.link);

						link.target = '_blank';
						icon.src = share.icon.toString();
						link.href = share.url.toString();
						link.title = share.label;

						link.append(icon, document.createElement('br'), share.label);
						body.append(link);

						link.addEventListener('click', function () {
							resolve();
							dialog.close();
						});
					});

					css(dialog, styles.dialog);
					css(header, styles.header);
					css(msg, styles.msg);
					css(close, styles.closeBtn);

					if (CSS.supports('width', 'fit-content')) {
						dialog.style.setProperty('width', 'fit-content');
					} else if (CSS.supports('width', '-moz-fit-content')) {
						dialog.style.setProperty('width', '-moz-fit-content');
					} else if (CSS.supports('width', '-webkit-fit-content')) {
						dialog.style.setProperty('width', '-webkit-fit-content');
					} else {
						dialog.style.setProperty('min-width', '320px');
					}

					header.append(close, msg);
					close.append('X');
					dialog.append(header);
					dialog.append(body);
					document.body.append(dialog);
					dialog.showModal();

					if (Element.prototype.hasOwnProperty('animate')) {
						var rects = dialog.getClientRects()[0];

						dialog.animate([{ top: '-' + rects.height + 'px' }, { top: 0 }], {
							duration: 400,
							easing: 'ease-out',
							fill: 'both'
						});
					}

					dialog.addEventListener('close', closeHandler, { once: true });
					document.addEventListener('keypress', closeDialog);
					document.addEventListener('click', closeDialog);
					close.addEventListener('click', function () {
						dialog.close('Share canceled');
					}, { once: true });
				}
			});
		};
	}
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var facebook = exports.facebook = {
	url: new URL('https://www.facebook.com/sharer/sharer.php?u&t'),
	icon: new URL('img/logos/facebook.svg', document.baseURI),
	label: 'Facebook'
};

var twitter = exports.twitter = {
	url: new URL('https://twitter.com/intent/tweet/?text&url'),
	icon: new URL('img/logos/twitter.svg', document.baseURI),
	label: 'Twitter'
};

var googlePlus = exports.googlePlus = {
	url: new URL('https://plus.google.com/share/?url'),
	icon: new URL('img/logos/google-plus.svg', document.baseURI),
	label: 'Google+'
};

var linkedIn = exports.linkedIn = {
	url: new URL('https://www.linkedin.com/shareArticle/?title&summary&url'),
	icon: new URL('img/logos/linkedin.svg', document.baseURI),
	label: 'LinkedIn'
};

var reddit = exports.reddit = {
	url: new URL('https://www.reddit.com/submit/?url&title'),
	icon: new URL('img/logos/reddit.svg', document.baseURI),
	label: 'Reddit'
};

var gmail = exports.gmail = {
	url: new URL('https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&su&body'),
	icon: new URL('img/logos/gmail.svg', document.baseURI),
	label: 'Gmail'
};

var email = exports.email = {
	url: new URL('mailto:?subject&body'),
	icon: new URL('img/adwaita-icons/actions/mail-send.svg', document.baseURI),
	label: 'Email'
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/index.min.js